!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t(require("react"), require("prop-types"), require("styled-components")) : "function" == typeof define && define.amd ? define(["react", "prop-types", "styled-components"], t) : "object" == typeof exports ? exports.icons = t(require("react"), require("prop-types"), require("styled-components")) : e.icons = t(e.react, e["prop-types"], e["styled-components"]);
}(window, function (e, t, l) {
  return function (e) {
    var t = {};

    function l(a) {
      if (t[a]) return t[a].exports;
      var c = t[a] = {
        i: a,
        l: !1,
        exports: {}
      };
      return e[a].call(c.exports, c, c.exports, l), c.l = !0, c.exports;
    }

    return l.m = e, l.c = t, l.d = function (e, t, a) {
      l.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: a
      });
    }, l.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, l.t = function (e, t) {
      if (1 & t && (e = l(e)), 8 & t) return e;
      if (4 & t && "object" == typeof e && e && e.__esModule) return e;
      var a = Object.create(null);
      if (l.r(a), Object.defineProperty(a, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var c in e) l.d(a, c, function (t) {
        return e[t];
      }.bind(null, c));
      return a;
    }, l.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return l.d(t, "a", t), t;
    }, l.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, l.p = "", l(l.s = 3);
  }([function (t, l) {
    t.exports = e;
  }, function (e, l) {
    e.exports = t;
  }, function (e, t) {
    e.exports = l;
  }, function (e, t, l) {
    "use strict";

    l.r(t), l.d(t, "ArrowDown", function () {
      return m;
    }), l.d(t, "ArrowLeft", function () {
      return u;
    }), l.d(t, "ArrowRight", function () {
      return p;
    }), l.d(t, "ArrowUp", function () {
      return g;
    }), l.d(t, "Calendar", function () {
      return f;
    }), l.d(t, "Check1", function () {
      return w;
    }), l.d(t, "Check2", function () {
      return L;
    }), l.d(t, "ChevronLeft", function () {
      return N;
    }), l.d(t, "ChevronRight", function () {
      return T;
    }), l.d(t, "Clock", function () {
      return b;
    }), l.d(t, "Document", function () {
      return k;
    }), l.d(t, "DoubleArrowDown", function () {
      return H;
    }), l.d(t, "DoubleArrowRight", function () {
      return O;
    }), l.d(t, "DoubleChevronLeft", function () {
      return P;
    }), l.d(t, "DoubleChevronRight", function () {
      return A;
    }), l.d(t, "Download", function () {
      return W;
    }), l.d(t, "Excel", function () {
      return F;
    }), l.d(t, "Edit", function () {
      return X;
    }), l.d(t, "Error", function () {
      return J;
    }), l.d(t, "Exclamation", function () {
      return Q;
    }), l.d(t, "Exit", function () {
      return ee;
    }), l.d(t, "EyeOpen", function () {
      return le;
    }), l.d(t, "EyeClosed", function () {
      return ce;
    }), l.d(t, "MagnifyingGlass", function () {
      return se;
    }), l.d(t, "Power", function () {
      return me;
    }), l.d(t, "ReadMessage", function () {
      return ue;
    }), l.d(t, "Settings", function () {
      return pe;
    }), l.d(t, "TwoWheelSettings", function () {
      return fe;
    }), l.d(t, "TrashIcon", function () {
      return we;
    }), l.d(t, "UnreadMessage", function () {
      return Le;
    }), l.d(t, "UserIcon", function () {
      return Ne;
    }), l.d(t, "Warning", function () {
      return Te;
    }), l.d(t, "Info", function () {
      return be;
    }), l.d(t, "InActive", function () {
      return ke;
    }), l.d(t, "Hover", function () {
      return He;
    }), l.d(t, "Clock2", function () {
      return Oe;
    }), l.d(t, "Check3", function () {
      return Pe;
    }), l.d(t, "ArrowDown2", function () {
      return Ae;
    }), l.d(t, "Active", function () {
      return We;
    }), l.d(t, "X", function () {
      return De;
    });

    var a = l(0),
        c = l.n(a),
        n = l(1),
        r = l.n(n),
        i = l(2),
        s = l.n(i),
        o = function o(e) {
      var t = e.size,
          l = e.color,
          a = e.theme,
          n = e.iconTitle,
          r = l || a && a.iconColor;
      return c.a.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 17 8",
        width: t,
        height: t
      }, c.a.createElement("title", null, n), c.a.createElement("g", {
        id: "Welcome",
        stroke: "none",
        strokeWidth: "1",
        fill: r,
        fillRule: "evenodd"
      }, c.a.createElement("g", {
        id: "reikningur",
        transform: "translate(-1034.000000, -605.000000)",
        fill: r
      }, c.a.createElement("path", {
        d: "M1042.49987,605 L1034.32686,612.295321 C1033.91866,612.658863 1033.88872,613.279136 1034.26,613.678934 C1034.63027,614.079711 1035.26104,614.109108 1035.66924,613.745567 L1042.49987,607.648657 L1049.33051,613.745567 C1049.73771,614.109108 1050.37048,614.079711 1050.74075,613.678934 C1051.11103,613.279136 1051.08108,612.658863 1050.67388,612.295321 L1042.49987,605 Z",
        transform: "translate(1042.500000, 609.500000) scale(1, -1) translate(-1042.500000, -609.500000) "
      }))));
    };

    o.propTypes = {
      color: r.a.string,
      iconTitle: r.a.string,
      size: r.a.number,
      theme: r.a.object
    }, o.defaultProps = {
      color: null,
      iconTitle: null,
      size: 26,
      theme: null
    };

    var m = Object(i.withTheme)(o),
        h = function h(e) {
      var t = e.size,
          l = e.color,
          a = e.theme,
          n = e.iconTitle,
          r = l || a && a.iconColor;
      return c.a.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 29.04492 27.43504",
        width: t,
        height: t
      }, c.a.createElement("title", null, n), c.a.createElement("g", {
        id: "Layer_2",
        "data-name": "Layer 2"
      }, c.a.createElement("g", {
        id: "Layer_1-2",
        "data-name": "Layer 1"
      }, c.a.createElement("path", {
        fill: r,
        d: "M.05664,13.997.0542,13.98539a.70048.70048,0,0,1-.02686-.12787.714.714,0,0,1-.02612-.13446L0,13.71726l.00122-.0058A.714.714,0,0,1,.02734,13.577a.70048.70048,0,0,1,.02686-.12787l.00244-.01166.006-.00885a.711.711,0,0,1,.10022-.14868.66626.66626,0,0,1,.04028-.06268l.00647-.00671.00134-.00134L12.8125.21726a.71754.71754,0,0,1,1.0293,1L2.41357,12.99949H28.32715a.71777.71777,0,1,1,0,1.43555H2.41357L13.8418,26.21726a.71754.71754,0,1,1-1.0293,1L.21094,14.22532.20959,14.224l-.00647-.00671a.66626.66626,0,0,1-.04028-.06268.711.711,0,0,1-.10022-.14868Z"
      }))));
    };

    h.propTypes = {
      color: r.a.string,
      iconTitle: r.a.string,
      size: r.a.number,
      theme: r.a.object
    }, h.defaultProps = {
      color: null,
      iconTitle: null,
      size: 26,
      theme: null
    };

    var u = Object(i.withTheme)(h),
        d = function d(e) {
      var t = e.size,
          l = e.color,
          a = e.theme,
          n = e.iconTitle,
          r = l || a && a.iconColor;
      return c.a.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 29.04492 27.43504",
        width: t,
        height: t,
        transform: "rotate(180)"
      }, c.a.createElement("title", null, n), c.a.createElement("g", {
        id: "Layer_2",
        "data-name": "Layer 2"
      }, c.a.createElement("g", {
        id: "Layer_1-2",
        "data-name": "Layer 1"
      }, c.a.createElement("path", {
        fill: r,
        d: "M.05664,13.997.0542,13.98539a.70048.70048,0,0,1-.02686-.12787.714.714,0,0,1-.02612-.13446L0,13.71726l.00122-.0058A.714.714,0,0,1,.02734,13.577a.70048.70048,0,0,1,.02686-.12787l.00244-.01166.006-.00885a.711.711,0,0,1,.10022-.14868.66626.66626,0,0,1,.04028-.06268l.00647-.00671.00134-.00134L12.8125.21726a.71754.71754,0,0,1,1.0293,1L2.41357,12.99949H28.32715a.71777.71777,0,1,1,0,1.43555H2.41357L13.8418,26.21726a.71754.71754,0,1,1-1.0293,1L.21094,14.22532.20959,14.224l-.00647-.00671a.66626.66626,0,0,1-.04028-.06268.711.711,0,0,1-.10022-.14868Z"
      }))));
    };

    d.propTypes = {
      iconTitle: r.a.string,
      size: r.a.number,
      color: r.a.string,
      theme: r.a.object
    }, d.defaultProps = {
      iconTitle: null,
      size: 26,
      color: null,
      theme: null
    };

    var p = Object(i.withTheme)(d),
        E = function E(e) {
      var t = e.size,
          l = e.color,
          a = e.theme,
          n = e.iconTitle,
          r = l || a && a.iconColor;
      return c.a.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 17 8",
        width: t,
        height: t
      }, c.a.createElement("title", null, n), c.a.createElement("g", {
        id: "Welcome",
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
      }, c.a.createElement("g", {
        id: "reikningur",
        transform: "translate(-1034.000000, -605.000000)",
        fill: r
      }, c.a.createElement("path", {
        d: "M1042.49987,605 L1034.32686,612.295321 C1033.91866,612.658863 1033.88872,613.279136 1034.26,613.678934 C1034.63027,614.079711 1035.26104,614.109108 1035.66924,613.745567 L1042.49987,607.648657 L1049.33051,613.745567 C1049.73771,614.109108 1050.37048,614.079711 1050.74075,613.678934 C1051.11103,613.279136 1051.08108,612.658863 1050.67388,612.295321 L1042.49987,605 Z"
      }))));
    };

    E.propTypes = {
      color: r.a.string,
      iconTitle: r.a.string,
      size: r.a.number,
      theme: r.a.object
    }, E.defaultProps = {
      color: null,
      iconTitle: null,
      size: 26,
      theme: null
    };

    var g = Object(i.withTheme)(E),
        v = function v(e) {
      var t = e.size,
          l = e.color,
          a = e.theme,
          n = e.iconTitle,
          r = l || a && a.iconColor;
      return c.a.createElement("svg", {
        width: t,
        height: t,
        fill: "none",
        stroke: "currentColor",
        strokeWidth: 2,
        strokeLinecap: "round",
        color: r,
        strokeLinejoin: "round",
        className: "prefix__feather prefix__feather-calendar"
      }, c.a.createElement("title", null, n), c.a.createElement("rect", {
        x: 3,
        y: 4,
        width: 18,
        height: 18,
        rx: 2,
        ry: 2
      }), c.a.createElement("path", {
        d: "M16 2v4M8 2v4M3 10h18"
      }));
    };

    v.propTypes = {
      color: r.a.string,
      iconTitle: r.a.string,
      size: r.a.number,
      theme: r.a.object
    }, v.defaultProps = {
      color: null,
      iconTitle: null,
      size: 26,
      theme: null
    };

    var f = Object(i.withTheme)(v),
        z = function z(e) {
      var t = e.size,
          l = e.color,
          a = e.theme,
          n = e.iconTitle,
          r = l || a && a.iconColor;
      return c.a.createElement("svg", {
        width: t,
        height: t,
        fill: "none",
        stroke: r,
        strokeWidth: 3,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }, c.a.createElement("title", null, n), c.a.createElement("path", {
        d: "M20 6L9 17l-5-5"
      }));
    };

    z.propTypes = {
      color: r.a.string,
      iconTitle: r.a.string,
      size: r.a.number,
      theme: r.a.object
    }, z.defaultProps = {
      color: null,
      iconTitle: null,
      size: 26,
      theme: null
    };

    var w = Object(i.withTheme)(z),
        y = function y(e) {
      var t = e.size,
          l = e.color,
          a = e.theme,
          n = e.iconTitle,
          r = l || a && a.iconColor;
      return c.a.createElement("svg", {
        viewBox: "0 0 19.241 18.481",
        width: t,
        height: t,
        color: r
      }, c.a.createElement("title", null, n), c.a.createElement("g", {
        "data-name": "Layer 2"
      }, c.a.createElement("path", {
        fill: r,
        d: "M0 7.428l9.136 11.053L19.241 0 8.717 13.991 0 7.428z",
        "data-name": "Layer 1"
      })));
    };

    y.propTypes = {
      color: r.a.string,
      iconTitle: r.a.string,
      size: r.a.number,
      theme: r.a.object
    }, y.defaultProps = {
      color: null,
      iconTitle: null,
      size: 26,
      theme: null
    };

    var L = Object(i.withTheme)(y),
        M = function M(e) {
      var t = e.size,
          l = e.color,
          a = e.theme,
          n = e.iconTitle,
          r = l || a && a.iconColor;
      return c.a.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: t,
        height: t,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: r,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        className: "feather feather-chevron-left"
      }, c.a.createElement("title", null, n), c.a.createElement("polyline", {
        points: "15 18 9 12 15 6"
      }));
    };

    M.propTypes = {
      color: r.a.string,
      iconTitle: r.a.string,
      size: r.a.number,
      theme: r.a.object
    }, M.defaultProps = {
      color: null,
      iconTitle: null,
      size: 26,
      theme: null
    };

    var N = Object(i.withTheme)(M),
        C = function C(e) {
      var t = e.size,
          l = e.color,
          a = e.theme,
          n = e.iconTitle,
          r = l || a && a.iconColor;
      return c.a.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: t,
        height: t,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: r,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        className: "feather feather-chevron-right"
      }, c.a.createElement("title", null, n), c.a.createElement("polyline", {
        points: "9 18 15 12 9 6"
      }));
    };

    C.propTypes = {
      color: r.a.string,
      iconTitle: r.a.string,
      size: r.a.number,
      theme: r.a.object
    }, C.defaultProps = {
      color: null,
      iconTitle: null,
      size: 26,
      theme: null
    };

    var T = Object(i.withTheme)(C),
        x = function x(e) {
      var t = e.size,
          l = e.color,
          a = e.theme,
          n = e.iconTitle,
          r = l || a && a.iconColor;
      return c.a.createElement("svg", {
        viewBox: "0 0 26.799 26.799",
        width: t,
        height: t,
        fill: r
      }, c.a.createElement("title", null, n), c.a.createElement("g", {
        "data-name": "Layer 2"
      }, c.a.createElement("g", {
        "data-name": "Layer 6"
      }, c.a.createElement("path", {
        className: "cls-1",
        d: "M13.4 26.799a13.4 13.4 0 1 1 13.399-13.4 13.414 13.414 0 0 1-13.4 13.4zm0-25.299a11.9 11.9 0 1 0 11.899 11.9 11.913 11.913 0 0 0-11.9-11.9z"
      }), c.a.createElement("path", {
        className: "cls-1",
        d: "M22.979 11.15a.748.748 0 0 0-.903-.559l-7.882 1.852a1.24 1.24 0 0 0-.795-.304 1.26 1.26 0 0 0-1.26 1.26 1.194 1.194 0 0 0 .04.203l-4.79 5.094a.75.75 0 1 0 1.093 1.028l4.786-5.09a1.182 1.182 0 0 0 .131.026 1.26 1.26 0 0 0 1.157-.761l7.864-1.848a.75.75 0 0 0 .559-.901z"
      }))));
    };

    x.propTypes = {
      color: r.a.string,
      iconTitle: r.a.string,
      size: r.a.number,
      theme: r.a.object
    }, x.defaultProps = {
      color: null,
      iconTitle: null,
      size: 26,
      theme: null
    };

    var b = Object(i.withTheme)(x),
        V = function V(e) {
      var t = e.size,
          l = e.color,
          a = e.theme,
          n = e.iconTitle,
          r = l || a && a.iconColor;
      return c.a.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: t,
        height: t,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: r,
        strokeWidth: "2"
      }, c.a.createElement("title", null, n), c.a.createElement("path", {
        d: "M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"
      }), c.a.createElement("polyline", {
        points: "14 2 14 8 20 8"
      }), c.a.createElement("line", {
        x1: "16",
        y1: "13",
        x2: "8",
        y2: "13"
      }), c.a.createElement("line", {
        x1: "16",
        y1: "17",
        x2: "8",
        y2: "17"
      }), c.a.createElement("polyline", {
        points: "10 9 9 9 8 9"
      }));
    };

    V.propTypes = {
      color: r.a.string,
      iconTitle: r.a.string,
      size: r.a.number,
      theme: r.a.object
    }, V.defaultProps = {
      color: null,
      iconTitle: null,
      size: 26,
      theme: null
    };

    var k = Object(i.withTheme)(V),
        j = function j(e) {
      var t = e.size,
          l = e.color,
          a = e.theme,
          n = e.iconTitle,
          r = l || a && a.iconColor;
      return c.a.createElement("svg", {
        viewBox: "0 0 320 512",
        height: t,
        width: t
      }, c.a.createElement("title", null, n), c.a.createElement("path", {
        stroke: r,
        fill: r,
        d: "M143 256.3L7 120.3c-9.4-9.4-9.4-24.6 0-33.9l22.6-22.6c9.4-9.4 24.6-9.4 33.9 0l96.4 96.4 96.4-96.4c9.4-9.4 24.6-9.4 33.9 0L313 86.3c9.4 9.4 9.4 24.6 0 33.9l-136 136c-9.4 9.5-24.6 9.5-34 .1zm34 192l136-136c9.4-9.4 9.4-24.6 0-33.9l-22.6-22.6c-9.4-9.4-24.6-9.4-33.9 0L160 352.1l-96.4-96.4c-9.4-9.4-24.6-9.4-33.9 0L7 278.3c-9.4 9.4-9.4 24.6 0 33.9l136 136c9.4 9.5 24.6 9.5 34 .1z"
      }));
    };

    j.propTypes = {
      color: r.a.string,
      iconTitle: r.a.string,
      size: r.a.number,
      theme: r.a.object
    }, j.defaultProps = {
      color: null,
      iconTitle: null,
      size: 26,
      theme: null
    };

    var H = Object(i.withTheme)(j),
        _ = function _(e) {
      var t = e.size,
          l = e.color,
          a = e.theme,
          n = e.iconTitle,
          r = l || a && a.iconColor;
      return c.a.createElement("svg", {
        viewBox: "0 0 448 512",
        height: t,
        width: t
      }, c.a.createElement("title", null, n), c.a.createElement("path", {
        stroke: r,
        fill: r,
        d: "M224.3 273l-136 136c-9.4 9.4-24.6 9.4-33.9 0l-22.6-22.6c-9.4-9.4-9.4-24.6 0-33.9l96.4-96.4-96.4-96.4c-9.4-9.4-9.4-24.6 0-33.9L54.3 103c9.4-9.4 24.6-9.4 33.9 0l136 136c9.5 9.4 9.5 24.6.1 34zm192-34l-136-136c-9.4-9.4-24.6-9.4-33.9 0l-22.6 22.6c-9.4 9.4-9.4 24.6 0 33.9l96.4 96.4-96.4 96.4c-9.4 9.4-9.4 24.6 0 33.9l22.6 22.6c9.4 9.4 24.6 9.4 33.9 0l136-136c9.4-9.2 9.4-24.4 0-33.8z"
      }));
    };

    _.propTypes = {
      color: r.a.string,
      iconTitle: r.a.string,
      size: r.a.number,
      theme: r.a.object
    }, _.defaultProps = {
      color: null,
      iconTitle: null,
      size: 26,
      theme: null
    };

    var O = Object(i.withTheme)(_),
        S = function S(e) {
      var t = e.size,
          l = e.color,
          a = e.theme,
          n = e.iconTitle,
          r = l || a && a.iconColor;
      return c.a.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: t,
        height: t,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: r,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        className: "feather feather-chevrons-left"
      }, c.a.createElement("title", null, n), c.a.createElement("polyline", {
        points: "11 17 6 12 11 7"
      }), c.a.createElement("polyline", {
        points: "18 17 13 12 18 7"
      }));
    };

    S.propTypes = {
      color: r.a.string,
      iconTitle: r.a.string,
      size: r.a.number,
      theme: r.a.object
    }, S.defaultProps = {
      color: null,
      iconTitle: null,
      size: 26,
      theme: null
    };

    var P = Object(i.withTheme)(S),
        B = function B(e) {
      var t = e.size,
          l = e.color,
          a = e.theme,
          n = e.iconTitle,
          r = l || a && a.iconColor;
      return c.a.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: t,
        height: t,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: r,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        className: "feather feather-chevrons-right"
      }, c.a.createElement("title", null, n), c.a.createElement("polyline", {
        points: "13 17 18 12 13 7"
      }), c.a.createElement("polyline", {
        points: "6 17 11 12 6 7"
      }));
    };

    B.propTypes = {
      color: r.a.string,
      iconTitle: r.a.string,
      size: r.a.number,
      theme: r.a.object
    }, B.defaultProps = {
      color: null,
      iconTitle: null,
      size: 26,
      theme: null
    };

    var A = Object(i.withTheme)(B),
        Z = function Z(e) {
      var t = e.size,
          l = e.color,
          a = e.theme,
          n = e.iconTitle,
          r = l || a && a.iconColor;
      return c.a.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: t,
        height: t,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: r,
        strokeWidth: "2"
      }, c.a.createElement("title", null, n), c.a.createElement("path", {
        d: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"
      }), c.a.createElement("polyline", {
        points: "7 10 12 15 17 10"
      }), c.a.createElement("line", {
        x1: "12",
        y1: "15",
        x2: "12",
        y2: "3"
      }));
    };

    Z.propTypes = {
      color: r.a.string,
      iconTitle: r.a.string,
      size: r.a.number,
      theme: r.a.object
    }, Z.defaultProps = {
      color: null,
      iconTitle: null,
      size: 26,
      theme: null
    };
    var W = Object(i.withTheme)(Z);

    function R() {
      var e = function (e, t) {
        t || (t = e.slice(0));
        return Object.freeze(Object.defineProperties(e, {
          raw: {
            value: Object.freeze(t)
          }
        }));
      }(["\n  .cls-1 {\n    fill: ", ";\n  }\n"]);

      return R = function R() {
        return e;
      }, e;
    }

    var D = s.a.div(R(), function (e) {
      return e.color;
    }),
        q = function q(e) {
      var t = e.size,
          l = e.color,
          a = e.theme,
          n = e.iconTitle,
          r = l || a && a.iconColor;
      return c.a.createElement(D, {
        color: r
      }, c.a.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: t,
        height: t,
        viewBox: "0 0 21.09999 22.6"
      }, c.a.createElement("title", null, n), c.a.createElement("g", {
        id: "Layer_2",
        "data-name": "Layer 2"
      }, c.a.createElement("g", {
        id: "pdf"
      }, c.a.createElement("g", {
        id: "Layer_2-2",
        "data-name": "Layer 2"
      }, c.a.createElement("g", {
        id: "Layer_1-2",
        "data-name": "Layer 1-2"
      }, c.a.createElement("g", {
        id: "Layer_1-3",
        "data-name": "Layer 1-3"
      }, c.a.createElement("g", {
        id: "Layer_2-2-2",
        "data-name": "Layer 2-2"
      }, c.a.createElement("g", {
        id: "Layer_1-2-2",
        "data-name": "Layer 1-2-2"
      }, c.a.createElement("g", {
        id: "Layer_3",
        "data-name": "Layer 3"
      }, c.a.createElement("polygon", {
        className: "cls-1",
        points: "16 19.2 16 21.3 1.3 21.3 1.3 1.3 12.7 1.3 12.7 4.6 16 4.6 16 8.5 17.3 8.5 17.3 3.9 13.4 0 0 0 0 22.6 17.3 22.6 17.3 19.2 16 19.2"
      }))))))), c.a.createElement("path", {
        className: "cls-1",
        d: "M3.2,9.3v9H21.1v-9Zm6.16639,7.42969-.4878-.97559c-.1997-.376-.32763-.65527-.47949-.96777H8.383c-.11182.3125-.24805.5918-.416.96777l-.44775.97559H6.12813l1.55908-2.72656L6.18428,11.34H7.5832l.47168.9834c.16016.32812.27979.59179.40772.89551h.01611c.12793-.34375.23193-.583.36768-.89551l.45605-.9834h1.39111l-1.519,2.63086,1.59912,2.75879Zm5.43164,0H11.43184V11.34h1.22265v4.36621h2.14356Zm2.041.08008a3.524,3.524,0,0,1-1.52734-.32813l.24805-1.00684a3.11725,3.11725,0,0,0,1.35058.335c.55957,0,.85547-.23145.85547-.583,0-.33594-.25586-.52832-.90332-.75977-.89551-.3125-1.47949-.80761-1.47949-1.59179,0-.91895.76758-1.62256,2.03906-1.62256a3.28971,3.28971,0,0,1,1.375.272l-.27148.9834a2.55307,2.55307,0,0,0-1.127-.25586c-.52832,0-.78418.23926-.78418.51953,0,.34375.30371.49609,1,.75977.95118.35156,1.39942.84765,1.39942,1.60742C19.01387,16.04219,18.31758,16.80977,16.83906,16.80977Z"
      })))));
    };

    q.propTypes = {
      color: r.a.string,
      iconTitle: r.a.string,
      size: r.a.number,
      theme: r.a.object
    }, q.defaultProps = {
      color: null,
      iconTitle: null,
      size: 26,
      theme: null
    };
    var F = Object(i.withTheme)(q);

    function I() {
      var e = function (e, t) {
        t || (t = e.slice(0));
        return Object.freeze(Object.defineProperties(e, {
          raw: {
            value: Object.freeze(t)
          }
        }));
      }(["\n  .st0 {\n    display: none;\n  }\n  .st1 {\n    display: inline;\n  }\n  .st2 {\n    display: inline;\n    fill: none;\n    stroke: #000000;\n    stroke-width: 1.5;\n    stroke-linecap: round;\n    stroke-linejoin: round;\n    stroke-miterlimit: 10;\n  }\n  .st3 {\n    fill: ", ";\n  }\n  .st4 {\n    display: inline;\n    fill: #a28352;\n  }\n  .st5 {\n    fill: #231f20;\n  }\n  .st6 {\n    display: inline;\n    fill: #231f20;\n  }\n  .st7 {\n    fill: none;\n    stroke: #231f20;\n    stroke-width: 1.5;\n    stroke-linecap: round;\n    stroke-miterlimit: 10;\n  }\n  .st8 {\n    fill: #a28352;\n  }\n  .st9 {\n    display: inline;\n    fill: none;\n    stroke: #444444;\n    stroke-width: 3;\n    stroke-linecap: round;\n    stroke-miterlimit: 10;\n  }\n  .st10 {\n    display: inline;\n    fill: #facb46;\n  }\n  .st11 {\n    display: inline;\n    fill: #d0023d;\n  }\n"]);

      return I = function I() {
        return e;
      }, e;
    }

    var G = s.a.div(I(), function (e) {
      var t = e.color,
          l = e.theme;
      return t || l && l.iconColor;
    }),
        U = function U(e) {
      var t = e.color,
          l = e.size,
          a = e.iconTitle;
      return c.a.createElement(G, {
        color: t
      }, c.a.createElement("svg", {
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        x: "0px",
        y: "0px",
        width: l,
        height: l,
        viewBox: "0 0 30 30",
        xmlSpace: "preserve"
      }, c.a.createElement("title", null, a), c.a.createElement("g", {
        id: "Layer_1",
        className: "st0"
      }, c.a.createElement("path", {
        className: "st1",
        d: "M29.2,23.9c0,0,0-0.1,0-0.1V7.9c0-0.1,0-0.1,0-0.2c0-0.1,0-0.3,0-0.4c-0.1-0.3-0.4-0.5-0.7-0.5H28H2H1.6 C1.2,6.7,1,6.9,0.9,7.3c0,0.1,0,0.3,0,0.4c0,0.1,0,0.1,0,0.2v15.9c0,0,0,0.1,0,0.1c-0.1,0.3-0.1,0.6,0.2,0.8 C1.2,25,1.6,25,1.8,24.9c0,0,0.1,0,0.1,0H28c0.1,0,0.1,0,0.1,0c0.3,0.1,0.7,0,0.9-0.2C29.2,24.5,29.3,24.2,29.2,23.9z M20.1,16.8 l6.6,6.7H3.4l6.6-6.7l-7.6,5.9V8.9l12.3,8.5c0.1,0.1,0.3,0.1,0.4,0.1s0.3,0,0.4-0.1l12.3-8.5v13.8L20.1,16.8z M26,8.2L15,16.3 L4,8.2H26z"
      }), c.a.createElement("path", {
        className: "st2",
        d: "M15,12.4"
      })), c.a.createElement("g", {
        id: "Layer_2",
        className: "st0"
      }, c.a.createElement("path", {
        className: "st2",
        d: "M15,12.4"
      }), c.a.createElement("path", {
        className: "st1",
        d: "M29.2,23.9c0,0,0-0.1,0-0.1V7.9c0-0.1,0-0.1,0-0.2c0-0.1,0-0.3,0-0.4c-0.1-0.3-0.4-0.5-0.7-0.5H28h-1.5V0.5 H3.7v6.2H2H1.6C1.2,6.7,1,6.9,0.9,7.3c0,0.1,0,0.3,0,0.4c0,0.1,0,0.1,0,0.2v15.9c0,0,0,0.1,0,0.1c-0.1,0.3-0.1,0.6,0.2,0.8 C1.2,25,1.6,25,1.8,24.9c0,0,0.1,0,0.1,0H28c0.1,0,0.1,0,0.1,0c0.3,0.1,0.7,0,0.9-0.2C29.2,24.5,29.3,24.2,29.2,23.9z M25.5,1.5 v7.1L15,16.3L4.7,8.8V1.5H25.5z M14.6,17.4c0.1,0.1,0.3,0.1,0.4,0.1s0.3,0,0.4-0.1l12.3-8.5v13.8l-7.6-5.9l6.6,6.7H3.4l6.6-6.7 l-7.6,5.9V8.9L14.6,17.4z"
      })), c.a.createElement("g", {
        id: "Layer_3",
        className: "st0"
      }, c.a.createElement("g", {
        className: "st1"
      }, c.a.createElement("path", {
        d: "M20.5,8.9c-0.4,0-0.8,0.3-0.8,0.8v14c0,0.1-0.1,0.2-0.2,0.2h-9.1c-0.1,0-0.2-0.1-0.2-0.2v-14c0-0.4-0.3-0.8-0.8-0.8 S8.8,9.3,8.8,9.7v14c0,0.9,0.7,1.7,1.7,1.7h9.1c0.9,0,1.7-0.7,1.7-1.7v-14C21.2,9.3,20.9,8.9,20.5,8.9z"
      }), c.a.createElement("path", {
        d: "M22.2,7h-3.8V6c0-1.3-1-2.3-2.3-2.3h-2.2c-1.3,0-2.3,1-2.3,2.3v1H7.8C7.4,7,7.1,7.3,7.1,7.7s0.3,0.8,0.8,0.8h14.4 c0.4,0,0.8-0.3,0.8-0.8S22.6,7,22.2,7z M13.1,6c0-0.4,0.4-0.8,0.8-0.8h2.2c0.4,0,0.8,0.4,0.8,0.8v1h-3.8V6z"
      }), c.a.createElement("path", {
        d: "M17.8,20.4v-9.2c0-0.4-0.3-0.8-0.8-0.8s-0.8,0.3-0.8,0.8v9.2c0,0.4,0.3,0.8,0.8,0.8S17.8,20.8,17.8,20.4z"
      }), c.a.createElement("path", {
        d: "M13.8,20.4v-9.2c0-0.4-0.3-0.8-0.8-0.8s-0.8,0.3-0.8,0.8v9.2c0,0.4,0.3,0.8,0.8,0.8S13.8,20.8,13.8,20.4z"
      }))), c.a.createElement("g", {
        id: "Layer_7",
        className: "st0"
      }, c.a.createElement("g", {
        className: "st1"
      }, c.a.createElement("path", {
        className: "st3",
        d: "M10.9,19.4c-0.5,0-1.1-0.1-1.7-0.2l-0.5-0.1v-1.8c-0.4-0.1-0.8-0.3-1.2-0.5l-1.3,1.3l-0.4-0.3 c-0.9-0.6-1.7-1.4-2.4-2.4L3.1,15l1.3-1.3C4.2,13.4,4,13,3.9,12.5H2.1L2,12c-0.1-0.6-0.2-1.1-0.2-1.7c0-0.5,0.1-1.1,0.2-1.7 l0.1-0.5h1.8C4,7.8,4.2,7.4,4.4,7L3.1,5.7l0.3-0.4c0.6-0.9,1.4-1.7,2.4-2.4l0.4-0.3l1.3,1.3c0.4-0.2,0.8-0.4,1.2-0.5V1.6l0.5-0.1 c1.2-0.2,2.2-0.2,3.4,0L13,1.6v1.8c0.4,0.1,0.8,0.3,1.2,0.5l1.3-1.3l0.4,0.3c0.9,0.6,1.7,1.4,2.4,2.4l0.3,0.4L17.3,7 c0.2,0.4,0.4,0.8,0.5,1.2h1.8l0.1,0.5c0.1,0.6,0.2,1.1,0.2,1.7c0,0.5-0.1,1.1-0.2,1.7l-0.1,0.5h-1.8c-0.1,0.4-0.3,0.8-0.5,1.2 l1.3,1.3l-0.3,0.4c-0.6,0.9-1.4,1.7-2.4,2.4l-0.4,0.3l-1.3-1.3c-0.4,0.2-0.8,0.4-1.2,0.5v1.8l-0.5,0.1 C11.9,19.3,11.4,19.4,10.9,19.4z M9.9,18c0.7,0.1,1.2,0.1,1.9,0v-1.7l0.5-0.1c0.6-0.1,1.2-0.4,1.7-0.7l0.4-0.3l1.2,1.2 c0.5-0.4,0.9-0.8,1.3-1.3l-1.2-1.2l0.3-0.4c0.3-0.5,0.6-1.1,0.7-1.7l0.1-0.5h1.7c0-0.3,0.1-0.6,0.1-0.9c0-0.3,0-0.6-0.1-0.9h-1.7 l-0.1-0.5c-0.1-0.6-0.4-1.2-0.7-1.7l-0.3-0.4L17,5.6c-0.4-0.5-0.8-0.9-1.3-1.3l-1.2,1.2L14,5.2c-0.5-0.3-1.1-0.6-1.7-0.7l-0.5-0.1 V2.7c-0.7-0.1-1.2-0.1-1.9,0v1.7L9.4,4.5C8.8,4.6,8.2,4.9,7.7,5.2L7.3,5.5L6.1,4.3C5.6,4.6,5.1,5.1,4.8,5.6L6,6.8L5.7,7.2 C5.4,7.7,5.1,8.3,5,8.9L4.9,9.4H3.2c0,0.3-0.1,0.6-0.1,0.9c0,0.3,0,0.6,0.1,0.9h1.7L5,11.8c0.1,0.6,0.4,1.2,0.7,1.7L6,13.9 l-1.2,1.2c0.4,0.5,0.8,0.9,1.3,1.3l1.2-1.2l0.4,0.3c0.5,0.3,1.1,0.6,1.7,0.7l0.5,0.1V18z M10.9,13.7c-1.8,0-3.3-1.5-3.3-3.3 S9,7,10.9,7c1.8,0,3.3,1.5,3.3,3.3S12.7,13.7,10.9,13.7z M10.9,8.3c-1.1,0-2.1,0.9-2.1,2.1s0.9,2.1,2.1,2.1s2.1-0.9,2.1-2.1 S12,8.3,10.9,8.3z"
      })), c.a.createElement("g", {
        className: "st1"
      }, c.a.createElement("path", {
        className: "st3",
        d: "M22.5,28.3l-0.4-1.1c-0.3,0-0.6,0-0.9,0l-0.5,1.1l-0.3-0.1c-0.4-0.1-0.8-0.2-1.1-0.4c-0.3-0.1-0.6-0.3-1-0.6 L18,27l0.5-1.1c-0.2-0.2-0.4-0.4-0.6-0.7l-1.1,0.4l-0.2-0.3c-0.4-0.7-0.7-1.4-0.8-2.1l0-0.3l1.1-0.4c0-0.3,0-0.6,0-0.9L15.9,21 l0.1-0.3c0.1-0.4,0.2-0.8,0.4-1.1c0.2-0.3,0.3-0.6,0.6-1l0.2-0.3l1.1,0.5c0.2-0.2,0.4-0.4,0.7-0.6l-0.4-1.1l0.3-0.2 c0.7-0.4,1.4-0.7,2.1-0.8l0.3,0l0.4,1.1c0.3,0,0.6,0,0.9,0l0.5-1.1l0.3,0.1c0.4,0.1,0.7,0.2,1.1,0.4c0.3,0.2,0.6,0.3,1,0.6 l0.3,0.2l-0.5,1.1c0.2,0.2,0.4,0.4,0.6,0.7l1.1-0.4l0.2,0.3c0.4,0.7,0.6,1.4,0.8,2.1l0,0.3L26.7,22c0,0.3,0,0.6,0,0.9l1.1,0.5 l-0.1,0.3c-0.1,0.4-0.2,0.7-0.4,1.1c-0.2,0.3-0.3,0.6-0.6,1L26.6,26l-1.1-0.5c-0.2,0.2-0.4,0.4-0.7,0.6l0.4,1.1l-0.3,0.2 c-0.7,0.4-1.4,0.7-2.1,0.8L22.5,28.3z M22.6,26.3l0.4,1.1c0.5-0.1,0.9-0.3,1.3-0.5l-0.4-1.1l0.2-0.2c0.4-0.2,0.7-0.5,1-0.9 l0.2-0.2l1,0.5c0.1-0.2,0.2-0.4,0.3-0.6c0.1-0.2,0.2-0.4,0.2-0.6l-1-0.5l0.1-0.3c0.1-0.4,0.1-0.9,0.1-1.3l0-0.3l1.1-0.4 c-0.1-0.4-0.3-0.9-0.5-1.3l-1.1,0.4l-0.2-0.2c-0.2-0.4-0.5-0.7-0.9-1l-0.2-0.2l0.5-1c-0.2-0.1-0.4-0.2-0.6-0.3 c-0.2-0.1-0.4-0.2-0.6-0.2l-0.5,1l-0.3-0.1c-0.4-0.1-0.9-0.1-1.3-0.1l-0.3,0L20.7,17c-0.5,0.1-0.9,0.3-1.3,0.5l0.4,1.1l-0.2,0.2 c-0.4,0.2-0.7,0.5-1,0.9l-0.2,0.2l-1-0.5c-0.1,0.2-0.2,0.4-0.3,0.6c-0.1,0.2-0.2,0.4-0.2,0.6l1,0.5l-0.1,0.3 c-0.1,0.4-0.1,0.9-0.1,1.3l0,0.3l-1.1,0.4c0.1,0.5,0.3,0.9,0.5,1.3l1.1-0.4l0.2,0.2c0.2,0.4,0.5,0.7,0.9,1l0.2,0.2l-0.5,1 c0.2,0.1,0.4,0.2,0.6,0.3c0.2,0.1,0.4,0.2,0.6,0.2l0.5-1l0.3,0.1c0.4,0.1,0.9,0.1,1.3,0.1L22.6,26.3z M21.8,24.4 c-0.3,0-0.6-0.1-0.9-0.2c-1.1-0.5-1.6-1.8-1.1-2.9c0.3-0.5,0.7-0.9,1.3-1.1c0.6-0.2,1.2-0.2,1.7,0.1c0.5,0.3,0.9,0.7,1.1,1.3 c0.2,0.6,0.2,1.2-0.1,1.7c-0.2,0.5-0.7,0.9-1.3,1.1C22.3,24.4,22.1,24.4,21.8,24.4z M21.8,20.8c-0.6,0-1.1,0.3-1.3,0.8 c-0.3,0.7,0,1.6,0.7,2h0c0.4,0.2,0.8,0.2,1.1,0c0.4-0.1,0.7-0.4,0.8-0.8c0.2-0.4,0.2-0.8,0-1.1c-0.1-0.4-0.4-0.7-0.8-0.8 C22.3,20.8,22,20.8,21.8,20.8z"
      }))), c.a.createElement("g", {
        id: "Layer_4",
        className: "st0"
      }, c.a.createElement("path", {
        className: "st4",
        d: "M-4.3-18.8c-13.6,0-24.6,11-24.6,24.6s11,24.6,24.6,24.6s24.6-11,24.6-24.6S9.3-18.8-4.3-18.8z M-8.7,14.3 c-1.5,0-2.9,0-4.4,0c0-4.4,0-8.7,0-13.1c1.4,0,2.9,0,4.4,0C-8.7,5.5-8.7,9.9-8.7,14.3z M-9.4-1c-1.1,0.7-3.5,0.6-3.9-1.4 c0-0.1-0.1-0.1-0.1-0.2c0-0.3,0-0.6,0-0.8c0.9-1.8,2.5-2.4,3.9-1.6C-8.1-4.1-8-1.9-9.4-1z M6.9,14.3c-0.7,0-1.4,0-2.1,0 c-0.7,0-1.4,0-2.2,0c0-0.3,0-0.6,0-0.9c0-2.3,0-4.6-0.1-6.9C2.4,5.1,1.6,4.3,0.3,4.3c-1.3,0-2.3,1.1-2.3,2.4c0,2.5,0,4.9,0,7.5 c-1.5,0-2.9,0-4.4,0c0-4.4,0-8.7,0-13.1c1.5,0,2.9,0,4.4,0c0,0.5,0,1,0,1.6c0.8-1,1.6-1.6,2.7-1.9c3.1-0.7,5.8,1.1,6.1,4.4 C7.1,8.2,6.9,11.2,6.9,14.3z"
      })), c.a.createElement("g", {
        id: "Layer_6",
        className: "st0"
      }, c.a.createElement("g", {
        className: "st1"
      }, c.a.createElement("path", {
        className: "st5",
        d: "M15,28.4c-7.4,0-13.4-6-13.4-13.4S7.6,1.6,15,1.6s13.4,6,13.4,13.4S22.4,28.4,15,28.4z M15,3.1 C8.4,3.1,3.1,8.4,3.1,15S8.4,26.9,15,26.9S26.9,21.6,26.9,15S21.6,3.1,15,3.1z"
      })), c.a.createElement("path", {
        className: "st6",
        d: "M24.6,12.8c-0.1-0.4-0.5-0.7-0.9-0.6L15.8,14c-0.2-0.2-0.5-0.3-0.8-0.3c-0.7,0-1.3,0.6-1.3,1.3 c0,0.1,0,0.1,0,0.2L9,20.3c-0.3,0.3-0.3,0.8,0,1.1c0.1,0.1,0.3,0.2,0.5,0.2c0.2,0,0.4-0.1,0.5-0.2l4.8-5.1c0,0,0.1,0,0.1,0 c0.5,0,1-0.3,1.2-0.8l7.9-1.8C24.4,13.6,24.7,13.2,24.6,12.8z"
      }), c.a.createElement("g", {
        className: "st1"
      }, c.a.createElement("path", {
        className: "st7",
        d: "M42.9,18.3"
      }))), c.a.createElement("g", {
        id: "Layer_5",
        className: "st0"
      }, c.a.createElement("path", {
        className: "st4",
        d: "M-3.9-18.8c-13.6,0-24.6,11-24.6,24.6s11,24.6,24.6,24.6s24.6-11,24.6-24.6S9.7-18.8-3.9-18.8z M2.9-3.6H0.5 c-2,0-2.3,1.2-2.3,2.5v2.8h4.7L2.2,7h-4.1v11.8h-4.7V7h-4.1V1.7h4.1v-3.2c0-4.1,2.3-6.3,5.9-6.3c1.7,0,2.9,0.1,3.5,0.2V-3.6z"
      })), c.a.createElement("g", {
        id: "Layer_8",
        className: "st0"
      }, c.a.createElement("g", {
        className: "st1"
      }, c.a.createElement("path", {
        className: "st8",
        d: "M104.6,21.3H17.4v-49.9h87.2V21.3z M21.9,16.9h78.3v-41H21.9V16.9z"
      })), c.a.createElement("g", {
        className: "st1"
      }, c.a.createElement("path", {
        className: "st8",
        d: "M61,12.9c-9.1,0-16.6-7.4-16.6-16.6c0-9.1,7.4-16.6,16.6-16.6s16.6,7.4,16.6,16.6C77.6,5.5,70.1,12.9,61,12.9 z M61-18c-7.9,0-14.3,6.4-14.3,14.3c0,7.9,6.4,14.3,14.3,14.3S75.4,4.3,75.4-3.6C75.4-11.6,68.9-18,61-18z"
      })), c.a.createElement("g", {
        className: "st1"
      }, c.a.createElement("rect", {
        x: "27.3",
        y: "-19.7",
        className: "st8",
        width: "9",
        height: "2.2"
      })), c.a.createElement("g", {
        className: "st1"
      }, c.a.createElement("rect", {
        x: "87.2",
        y: "-19.7",
        className: "st8",
        width: "9",
        height: "2.2"
      })), c.a.createElement("g", {
        className: "st1"
      }, c.a.createElement("rect", {
        x: "27.3",
        y: "10.7",
        className: "st8",
        width: "9",
        height: "2.2"
      })), c.a.createElement("g", {
        className: "st1"
      }, c.a.createElement("rect", {
        x: "87.2",
        y: "10.7",
        className: "st8",
        width: "9",
        height: "2.2"
      })), c.a.createElement("g", {
        className: "st1"
      }, c.a.createElement("polygon", {
        className: "st8",
        points: "-62.5,-14.2 -60,-14.2 -60,-21.6 -52.6,-21.6 -52.6,-24.1 -60,-24.1 -60,-31.5 -62.5,-31.5 -62.5,-24.1 -69.9,-24.1 -69.9,-21.6 -62.5,-21.6 \t\t"
      }), c.a.createElement("polygon", {
        className: "st8",
        points: "-56,0.9 -61.2,6.1 -66.5,0.9 -68.2,2.6 -63,7.9 -68.2,13.1 -66.5,14.8 -61.2,9.6 -56,14.8 -54.2,13.1 -59.5,7.9 -54.2,2.6 \t\t"
      }), c.a.createElement("rect", {
        x: "-42.9",
        y: "6.6",
        transform: "matrix(0.707 -0.7072 0.7072 0.707 -15.5724 -21.8866)",
        className: "st8",
        width: "17.3",
        height: "2.5"
      }), c.a.createElement("rect", {
        x: "-42.9",
        y: "-24.1",
        className: "st8",
        width: "17.3",
        height: "2.5"
      }), c.a.createElement("path", {
        className: "st8",
        d: "M-84.2-42.5v72.1h72.1v-72.1H-84.2z M-17,24.7h-62.3v-62.3H-17V24.7z"
      }), c.a.createElement("circle", {
        className: "st8",
        cx: "-39.5",
        cy: "2.5",
        r: "2.1"
      }), c.a.createElement("path", {
        className: "st8",
        d: "M-28.7,11.4c-1.1,0-1.9,0.9-1.9,1.9c0,1.1,0.9,1.9,1.9,1.9c1.1,0,1.9-0.9,1.9-1.9 C-26.8,12.2-27.7,11.4-28.7,11.4z"
      })), c.a.createElement("g", {
        className: "st1"
      }, c.a.createElement("polygon", {
        className: "st8",
        points: "-123.9,24.7 -123.9,19.4 -126.3,19.4 -126.3,24.7 -133.7,24.7 -133.7,19.4 -136.1,19.4 -136.1,24.7 -143.5,24.7 -143.5,19.4 -146,19.4 -146,24.7 -153.4,24.7 -153.4,19.4 -155.8,19.4 -155.8,24.7 -163.2,24.7 -163.2,19.4 -165.6,19.4 -165.6,24.7 -177.6,24.7 -177.6,14.2 -173.3,14.2 -173.3,11.7 -177.6,11.7 -177.6,4.3 -173.3,4.3 -173.3,1.9 -177.6,1.9 -177.6,-5.5 -173.3,-5.5 -173.3,-7.9 -177.6,-7.9 -177.6,-15.3 -173.3,-15.3 -173.3,-17.8 -177.6,-17.8 -177.6,-25.1 -173.3,-25.1 -173.3,-27.6 -177.6,-27.6 -177.6,-40.1 -182.5,-40.1 -182.5,29.6 -112.8,29.6 -112.8,24.7 \t\t"
      }), c.a.createElement("path", {
        className: "st8",
        d: "M-155.2-11.9h-10.2v26h10.2V-11.9z M-157.7,11.7h-5.3V-9.4h5.3V11.7z"
      }), c.a.createElement("path", {
        className: "st8",
        d: "M-138.7-29.1h-10.2v43.2h10.2V-29.1z M-141.2,11.7h-5.3v-38.3h5.3V11.7z"
      }), c.a.createElement("path", {
        className: "st8",
        d: "M-122.2-19.2h-10.2v33.4h10.2V-19.2z M-124.7,11.7h-5.3v-28.5h5.3V11.7z"
      })), c.a.createElement("g", {
        className: "st1"
      }, c.a.createElement("path", {
        className: "st8",
        d: "M-215.2,15.6v-48h-23.4l0,0l-11-7.7l-11,7.7l0,0H-284v48h33.6v11.1h-8.4V30h18.5v-3.3h-8.4V15.6H-215.2z M-249.6-38.2l8.3,5.8h-16.6L-249.6-38.2z M-279.9-28.3h60.5v39.7h-60.5V-28.3z"
      }), c.a.createElement("path", {
        className: "st8",
        d: "M-244.9-22.5l-0.8,0.2c-3.5,1-6.1,3.9-6.8,7.4l-0.1,0.8l10.6,2.7L-244.9-22.5z M-246-20.4l1.7,6.7l-6.4-1.6 C-250-17.6-248.3-19.5-246-20.4z"
      }), c.a.createElement("path", {
        className: "st8",
        d: "M-238.5-20.9c-0.8,0-1.6,0.1-2.5,0.3l0,0l-0.6,0.2c-0.3,0.1-0.7,0.2-1,0.3c0,0,0,0,0,0c0,0,0,0,0,0l0.3,0.7 l0,0l2.7,10.5l-10.8-2.8l-0.2,0.9c0,0,0,0,0,0l0,0c-0.1,0.8-0.2,1.5-0.2,2.2c0,6.8,5.5,12.3,12.3,12.3c6.8,0,12.3-5.5,12.3-12.3 S-231.7-20.9-238.5-20.9z M-238.5,2c-5.9,0-10.6-4.8-10.6-10.6c0-0.3,0-0.7,0.1-1l11.7,3l-3.2-12.4c0.7-0.1,1.4-0.2,2-0.2 c5.9,0,10.6,4.8,10.6,10.6S-232.6,2-238.5,2z"
      }), c.a.createElement("rect", {
        x: "-272.9",
        y: "-16.9",
        className: "st8",
        width: "15.8",
        height: "1.6"
      }), c.a.createElement("rect", {
        x: "-272.9",
        y: "-10.3",
        className: "st8",
        width: "12.5",
        height: "1.6"
      }), c.a.createElement("rect", {
        x: "-272.9",
        y: "-3.7",
        className: "st8",
        width: "7.6",
        height: "1.6"
      }))), c.a.createElement("g", {
        id: "simi",
        className: "st0"
      }, c.a.createElement("g", {
        className: "st1"
      }, c.a.createElement("path", {
        d: "M18.5,2.7h-7.1C9.9,2.7,8.6,4,8.6,5.6v19.1c0,1.6,1.3,2.9,2.9,2.9h7.1c1.6,0,2.9-1.3,2.9-2.9V5.6 C21.4,4,20.1,2.7,18.5,2.7z M10.1,7.8h9.9v13.8h-9.9V7.8z M11.5,4.2h7.1c0.8,0,1.4,0.6,1.4,1.4v1.2h-9.9V5.6 C10.1,4.8,10.7,4.2,11.5,4.2z M18.5,26.1h-7.1c-0.8,0-1.4-0.6-1.4-1.4v-2.1h9.9v2.1C19.9,25.5,19.3,26.1,18.5,26.1z"
      })), c.a.createElement("g", {
        className: "st1"
      }, c.a.createElement("path", {
        d: "M15,25.2c-0.5,0-0.8-0.4-0.9-0.8l0,0c0-0.5,0.3-0.9,0.8-0.9c0.2,0,0.5,0.1,0.6,0.2c0.2,0.2,0.3,0.4,0.3,0.6 C15.9,24.8,15.6,25.2,15,25.2C15,25.2,15,25.2,15,25.2z M14.6,24.4c0,0.2,0.2,0.4,0.4,0.4c0.2,0,0.4-0.2,0.4-0.4 c0-0.1-0.1-0.2-0.1-0.3S15.1,24,15,24C14.8,24,14.6,24.2,14.6,24.4L14.6,24.4z"
      }))), c.a.createElement("g", {
        id: "hus",
        className: "st0"
      }, c.a.createElement("g", {
        className: "st1"
      }, c.a.createElement("path", {
        d: "M25.9,27.8h-9.1v-8h-3.6v8H4.1V16.4L1,14.8L15,2.5l14,12.3l-3.1,1.5V27.8z M18.6,26h5.6V15.3l1.7-0.8L15,4.9L4.2,14.4 l1.7,0.8V26h5.6v-8h7.1V26z"
      }))), c.a.createElement("g", {
        id: "las",
        className: "st0"
      }, c.a.createElement("path", {
        className: "st1",
        d: "M24.8,12.8h-1.3V9.3c0-4.7-3.8-8.4-8.4-8.4S6.6,4.6,6.6,9.3v3.6H5.2c-0.9,0-1.6,0.7-1.6,1.6v13.1 c0,0.9,0.7,1.6,1.6,1.6h19.6c0.9,0,1.6-0.7,1.6-1.6V14.4C26.4,13.6,25.7,12.8,24.8,12.8z M8.4,9.3c0-3.6,3-6.6,6.6-6.6 s6.6,3,6.6,6.6v3.6H8.4V9.3z M24.5,27.3h-19V14.7h1.1h16.9h1.1V27.3z"
      }), c.a.createElement("path", {
        className: "st1",
        d: "M16.8,19.2c0-1-0.8-1.8-1.8-1.8s-1.8,0.8-1.8,1.8c0,0.7,0.4,1.2,0.9,1.5l-0.9,3.4h3.5l-0.8-3.4 C16.4,20.4,16.8,19.9,16.8,19.2z"
      })), c.a.createElement("g", {
        id: "quit",
        className: "st0"
      }, c.a.createElement("g", {
        className: "st1"
      }, c.a.createElement("path", {
        d: "M15.5,28.6c-7,0-12.7-5.7-12.7-12.7c0-4.6,2.5-8.9,6.6-11.2l1,1.7c-3.4,1.9-5.5,5.5-5.5,9.4c0,5.9,4.8,10.7,10.7,10.7 c5.9,0,10.7-4.8,10.7-10.7c0-3.8-2.1-7.4-5.4-9.3l1-1.7c3.9,2.3,6.4,6.5,6.4,11C28.3,22.9,22.5,28.6,15.5,28.6z"
      })), c.a.createElement("g", {
        className: "st1"
      }, c.a.createElement("rect", {
        x: "14.5",
        y: "2.6",
        width: "2",
        height: "12.4"
      }))), c.a.createElement("g", {
        id: "pdf",
        className: "st0"
      }, c.a.createElement("g", {
        id: "Layer_2_1_",
        className: "st1"
      }, c.a.createElement("g", {
        id: "Layer_1-2"
      }, c.a.createElement("g", {
        id: "Layer_1-3"
      }, c.a.createElement("g", {
        id: "Layer_2-2"
      }, c.a.createElement("g", {
        id: "Layer_1-2-2"
      }, c.a.createElement("g", {
        id: "Layer_3_1_"
      }, c.a.createElement("polygon", {
        className: "st8",
        points: "20.5,22.9 20.5,25 5.8,25 5.8,5 17.1,5 17.1,8.3 20.5,8.3 20.5,12.2 21.8,12.2 21.8,7.6 17.8,3.7 4.4,3.7 4.4,26.3 21.8,26.3 21.8,22.9 \t\t\t\t\t\t\t"
      }), c.a.createElement("path", {
        className: "st8",
        d: "M12,16.2c-0.3,0-0.4,0-0.4,0.1v1.5H12c0.6,0,1-0.3,1-0.8S12.6,16.2,12,16.2z"
      }), c.a.createElement("path", {
        className: "st8",
        d: "M16.5,16.2c-0.3,0-0.4,0-0.5,0.1v3.3h0.4c0.8,0.1,1.6-0.5,1.7-1.3c0-0.1,0-0.1,0-0.2v-0.3 c0.1-0.8-0.5-1.5-1.3-1.6c0,0,0,0,0,0H16.5z"
      }), c.a.createElement("path", {
        className: "st8",
        d: "M7.6,13v9h17.9v-9L7.6,13z M13.6,18.1c-0.5,0.4-1.1,0.6-1.7,0.5h-0.3v1.8h-1.2v-5.1 c0.5-0.1,1-0.1,1.5-0.1c0.5,0,1.1,0.1,1.5,0.4c0.4,0.3,0.6,0.7,0.6,1.2C14.2,17.3,14,17.8,13.6,18.1z M18.5,19.8 c-0.7,0.5-1.6,0.7-2.4,0.6c-0.6,0-1-0.1-1.3-0.1v-5c0.5-0.1,1-0.1,1.5-0.1c0.7-0.1,1.5,0.2,2.1,0.6c0.6,0.4,0.9,1.2,0.8,1.9 C19.5,18.5,19.2,19.3,18.5,19.8z M23.2,16.2h-2v1.2h1.9v1h-1.9v2H20v-5.1h3.1L23.2,16.2z"
      }))))))), c.a.createElement("line", {
        className: "st9",
        x1: "-94.1",
        y1: "-117",
        x2: "-74.8",
        y2: "-97.7"
      }), c.a.createElement("line", {
        className: "st9",
        x1: "-74.8",
        y1: "-117",
        x2: "-94.1",
        y2: "-97.7"
      })), c.a.createElement("g", {
        id: "new_window",
        className: "st0"
      }, c.a.createElement("g", {
        className: "st1"
      }, c.a.createElement("path", {
        className: "st8",
        d: "M22.7,26.6H3.5V7.4h6.6c0.6,0,1,0.4,1,1s-0.4,1-1,1H5.5v15.2h15.2v-4.9c0-0.6,0.4-1,1-1s1,0.4,1,1V26.6z"
      })), c.a.createElement("path", {
        className: "st4",
        d: "M14.9,8.3L14.9,8.3C15,8.7,15.3,9,15.7,9l3.9,0l-7.4,7.6c-0.3,0.3-0.3,0.8,0,1.1c0.2,0.1,0.3,0.2,0.5,0.2 c0.2,0,0.4-0.1,0.6-0.2l7.5-7.6l0.1,3.9c0,0.4,0.4,0.7,0.8,0.8h0c0.5,0,0.8-0.4,0.8-0.8l-0.1-6.7l-6.7,0.1 C15.3,7.5,14.9,7.8,14.9,8.3z"
      })), c.a.createElement("g", {
        id: "Layer_15",
        className: "st0"
      }, c.a.createElement("g", {
        className: "st1"
      }, c.a.createElement("path", {
        className: "st8",
        d: "M26.2,25.1h-22V5.8h22V25.1z M6.3,23.1h18V7.8h-18V23.1z"
      })), c.a.createElement("circle", {
        className: "st4",
        cx: "20",
        cy: "12.1",
        r: "1.3"
      }), c.a.createElement("polygon", {
        className: "st4",
        points: "12.8,12.9 16.6,17.8 18.3,16.4 22.1,20.7 7.8,20.7 \t"
      })), c.a.createElement("g", {
        id: "Layer_15_copy",
        className: "st0"
      }, c.a.createElement("g", {
        className: "st1"
      }, c.a.createElement("path", {
        className: "st8",
        d: "M23.2,5.8V2.8h-2v2.9h-12V2.8h-2v2.9h-3v19.3h22V5.8H23.2z M24.2,23.1h-18V7.8h18V23.1z"
      }), c.a.createElement("rect", {
        x: "9",
        y: "12.8",
        className: "st8",
        width: "2.7",
        height: "2.7"
      }), c.a.createElement("rect", {
        x: "14",
        y: "12.8",
        className: "st8",
        width: "2.7",
        height: "2.7"
      }), c.a.createElement("rect", {
        x: "19",
        y: "12.8",
        className: "st8",
        width: "2.7",
        height: "2.7"
      }), c.a.createElement("rect", {
        x: "9",
        y: "17.8",
        className: "st8",
        width: "2.7",
        height: "2.7"
      }), c.a.createElement("rect", {
        x: "14",
        y: "17.8",
        className: "st8",
        width: "2.7",
        height: "2.7"
      }), c.a.createElement("rect", {
        x: "19",
        y: "17.8",
        className: "st8",
        width: "2.7",
        height: "2.7"
      }))), c.a.createElement("g", {
        id: "upphropun",
        className: "st0"
      }, c.a.createElement("path", {
        className: "st10",
        d: "M15,19.6L15,19.6c-0.7,0-1.3-0.5-1.4-1.2L12.2,4.6c-0.1-1.7,1.2-3.1,2.9-3.1h0c1.7,0,3,1.4,2.9,3.1l-1.6,13.8 C16.3,19.1,15.7,19.6,15,19.6z"
      }), c.a.createElement("circle", {
        className: "st10",
        cx: "15.1",
        cy: "25.9",
        r: "2.6"
      })), c.a.createElement("g", {
        id: "x",
        className: "st0"
      }, c.a.createElement("path", {
        className: "st11",
        d: "M17.6,14.7l10-10c0.8-0.8,0.8-2,0-2.8c-0.8-0.8-2-0.8-2.8,0l-10,10l-10-10c-0.8-0.8-2-0.8-2.8,0 c-0.8,0.8-0.8,2,0,2.8l10,10l-10,10c-0.8,0.8-0.8,2,0,2.8c0.4,0.4,0.9,0.6,1.4,0.6s1-0.2,1.4-0.6l10-10l10,10 c0.4,0.4,0.9,0.6,1.4,0.6s1-0.2,1.4-0.6c0.8-0.8,0.8-2,0-2.8L17.6,14.7z"
      })), c.a.createElement("g", {
        id: "Layer_19",
        className: "st0"
      }, c.a.createElement("g", {
        className: "st1"
      }, c.a.createElement("path", {
        className: "st8",
        d: "M20.5,4.4h-11c-2.8,0-5.1,2.3-5.1,5.1v11c0,2.8,2.3,5.1,5.1,5.1h11c2.8,0,5.1-2.3,5.1-5.1v-11 C25.6,6.7,23.3,4.4,20.5,4.4z M23.6,20.5c0,1.7-1.4,3.1-3.1,3.1h-11c-1.7,0-3.1-1.4-3.1-3.1v-11c0-1.7,1.4-3.1,3.1-3.1h11 c1.7,0,3.1,1.4,3.1,3.1V20.5z"
      }), c.a.createElement("polygon", {
        className: "st8",
        points: "16,10.9 14,10.9 14,14 10.9,14 10.9,16 14,16 14,19.1 16,19.1 16,16 19.1,16 19.1,14 16,14 \t\t"
      }))), c.a.createElement("g", {
        id: "Layer_20"
      }, c.a.createElement("path", {
        className: "st3",
        d: "M26.4,6.1l-3.9-3.9c-0.6-0.6-1.7-0.6-2.3,0L5.9,16.7l-1.5,7.7l7.7-1.5L26.4,8.4c0.3-0.3,0.5-0.7,0.5-1.1 C26.9,6.8,26.7,6.4,26.4,6.1z M11.2,21.2L8,21.8l-1.2-1.2l0.6-3.2L18.7,6.3l1.6,1.6L9.6,18.6l0.5,0.5L20.8,8.4l1.5,1.5L11.2,21.2z M22.9,9.4l-3.7-3.7l2.2-2.2l3.7,3.7L22.9,9.4z"
      }))));
    };

    U.propTypes = {
      iconTitle: r.a.string,
      size: r.a.number,
      color: r.a.string
    }, U.defaultProps = {
      iconTitle: null,
      size: 26,
      color: ""
    };

    var X = Object(i.withTheme)(U),
        Y = function Y(e) {
      var t = e.size,
          l = e.color,
          a = e.theme,
          n = e.iconTitle,
          r = l || a && a.iconColor;
      return c.a.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 22.33691 22.33789",
        width: t,
        height: t
      }, c.a.createElement("title", null, n), c.a.createElement("g", {
        id: "Layer_2",
        "data-name": "Layer 2"
      }, c.a.createElement("g", {
        id: "Layer_1-2",
        "data-name": "Layer 1"
      }, c.a.createElement("g", {
        id: "Welcome"
      }, c.a.createElement("g", {
        id: "medis_styleguide",
        "data-name": "medis styleguide"
      }, c.a.createElement("g", {
        id: "Group-2"
      }, c.a.createElement("g", {
        id: "Oval-3"
      }, c.a.createElement("path", {
        fill: r,
        d: "M11.16895,22.33789a11.16895,11.16895,0,1,1,11.168-11.16895A11.18208,11.18208,0,0,1,11.16895,22.33789ZM11.16895,1a10.16895,10.16895,0,1,0,10.168,10.16895A10.18015,10.18015,0,0,0,11.16895,1Z"
      })), c.a.createElement("g", {
        id: "Combined-Shape"
      }, c.a.createElement("polygon", {
        fill: r,
        points: "11.168 10.606 7.054 6.491 6.472 7.073 10.587 11.188 6.309 15.466 6.891 16.048 11.168 11.77 15.446 16.048 16.028 15.466 11.75 11.188 15.865 7.073 15.283 6.491 11.168 10.606"
      }))))))));
    };

    Y.propTypes = {
      color: r.a.string,
      iconTitle: r.a.string,
      size: r.a.number,
      theme: r.a.object
    }, Y.defaultProps = {
      color: null,
      iconTitle: null,
      size: 26,
      theme: null
    };

    var J = Object(i.withTheme)(Y),
        K = function K(e) {
      var t = e.size,
          l = e.color,
          a = e.theme,
          n = e.iconTitle,
          r = l || a && a.iconColor;
      return c.a.createElement("svg", {
        width: t,
        height: t,
        stroke: r,
        strokeWidth: "2",
        fill: r,
        contentScriptType: "text/ecmascript",
        contentStyleType: "text/css",
        enableBackground: "new 0 0 2048 2048",
        id: "Layer_1",
        preserveAspectRatio: "xMidYMid meet",
        version: "1.1",
        viewBox: "97.33300018310547 0 445.333984375 2048",
        xmlSpace: "preserve",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        zoomAndPan: "magnify"
      }, c.a.createElement("title", null, n), c.a.createElement("path", {
        d: "M512,1376v224c0,17.333-6.333,32.333-19,45s-27.667,19-45,19H192c-17.333,0-32.333-6.333-45-19s-19-27.667-19-45v-224  c0-17.333,6.333-32.333,19-45s27.667-19,45-19h256c17.333,0,32.333,6.333,45,19S512,1358.667,512,1376z M542,320l-28,768  c-0.667,17.333-7.5,32.333-20.5,45s-28.167,19-45.5,19H192c-17.333,0-32.5-6.333-45.5-19s-19.833-27.667-20.5-45L98,320  c-0.667-17.333,5.167-32.333,17.5-45s27.167-19,44.5-19h320c17.333,0,32.167,6.333,44.5,19S542.667,302.667,542,320z"
      }));
    };

    K.propTypes = {
      color: r.a.string,
      iconTitle: r.a.string,
      size: r.a.number,
      theme: r.a.object
    }, K.defaultProps = {
      color: null,
      iconTitle: null,
      size: 26,
      theme: null
    };

    var Q = Object(i.withTheme)(K),
        $ = function $(e) {
      var t = e.size,
          l = e.color,
          a = e.theme,
          n = e.iconTitle,
          r = l || a && a.iconColor;
      return c.a.createElement("svg", {
        width: t,
        height: t,
        fill: "none",
        stroke: "currentColor",
        strokeWidth: 2,
        strokeLinecap: "round",
        strokeLinejoin: "round",
        viewBox: "0 0 25 25",
        className: "feather feather-x",
        color: r
      }, c.a.createElement("title", null, n), c.a.createElement("path", {
        d: "M18 6L6 18M6 6l12 12"
      }));
    };

    $.propTypes = {
      color: r.a.string,
      iconTitle: r.a.string,
      size: r.a.number,
      theme: r.a.object
    }, $.defaultProps = {
      color: null,
      iconTitle: null,
      size: 26,
      theme: null
    };

    var ee = Object(i.withTheme)($),
        te = function te(e) {
      var t = e.size,
          l = e.color,
          a = e.theme,
          n = e.iconTitle,
          r = l || a && a.iconColor;
      return c.a.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: t,
        height: t,
        stroke: r,
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: "2"
      }, c.a.createElement("title", null, n), c.a.createElement("path", {
        d: "M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"
      }), c.a.createElement("circle", {
        cx: "12",
        cy: "12",
        r: "3"
      }));
    };

    te.propTypes = {
      color: r.a.string,
      iconTitle: r.a.string,
      size: r.a.number,
      theme: r.a.object
    }, te.defaultProps = {
      color: null,
      iconTitle: null,
      size: 26,
      theme: null
    };

    var le = Object(i.withTheme)(te),
        ae = function ae(e) {
      var t = e.size,
          l = e.color,
          a = e.theme,
          n = e.iconTitle,
          r = l || a && a.iconColor;
      return c.a.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: t,
        height: t,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: r,
        strokeWidth: "2"
      }, c.a.createElement("title", null, n), c.a.createElement("path", {
        d: "M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"
      }), c.a.createElement("line", {
        x1: "1",
        y1: "1",
        x2: "23",
        y2: "23"
      }));
    };

    ae.propTypes = {
      color: r.a.string,
      iconTitle: r.a.string,
      size: r.a.number,
      theme: r.a.object
    }, ae.defaultProps = {
      color: null,
      iconTitle: null,
      size: 26,
      theme: null
    };
    var ce = Object(i.withTheme)(ae);

    function ne() {
      var e = function (e, t) {
        t || (t = e.slice(0));
        return Object.freeze(Object.defineProperties(e, {
          raw: {
            value: Object.freeze(t)
          }
        }));
      }(["\n  .cls-1 {\n    fill: ", ";\n  }\n"]);

      return ne = function ne() {
        return e;
      }, e;
    }

    var re = s.a.div(ne(), function (e) {
      return e.color;
    }),
        ie = function ie(e) {
      var t = e.size,
          l = e.color,
          a = e.theme,
          n = e.iconTitle,
          r = l || a && a.iconColor;
      return c.a.createElement(re, {
        color: r
      }, c.a.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: t,
        height: t,
        viewBox: "0 0 18.94824 18.94824"
      }, c.a.createElement("title", null, n), c.a.createElement("g", {
        id: "Layer_2",
        "data-name": "Layer 2"
      }, c.a.createElement("g", {
        id: "Layer_21",
        "data-name": "Layer 21"
      }, c.a.createElement("path", {
        className: "cls-1",
        d: "M17.90918,16.84473l-4.227-4.227a7.71337,7.71337,0,1,0-1.06061,1.06048l4.22711,4.22711a.74992.74992,0,0,0,1.06055-1.06054ZM3.32178,12.11426a6.22,6.22,0,1,1,8.79638,0A6.17861,6.17861,0,0,1,3.32178,12.11426Z"
      })))));
    };

    ie.propTypes = {
      color: r.a.string,
      iconTitle: r.a.string,
      size: r.a.number,
      theme: r.a.object
    }, ie.defaultProps = {
      color: null,
      iconTitle: null,
      size: 26,
      theme: null
    };

    var se = Object(i.withTheme)(ie),
        oe = function oe(e) {
      var t = e.size,
          l = e.color,
          a = e.theme,
          n = e.iconTitle,
          r = l || a && a.iconColor;
      return c.a.createElement("svg", {
        width: t,
        height: t,
        fill: "none",
        color: r,
        stroke: "currentColor",
        strokeWidth: 3,
        strokeLinecap: "round",
        strokeLinejoin: "round",
        viewBox: "0 0 25 25",
        className: "feather feather-power"
      }, c.a.createElement("title", null, n), c.a.createElement("path", {
        d: "M18.36 6.64a9 9 0 1 1-12.73 0M12 2v10"
      }));
    };

    oe.propTypes = {
      color: r.a.string,
      iconTitle: r.a.string,
      size: r.a.number,
      theme: r.a.object
    }, oe.defaultProps = {
      color: null,
      iconTitle: null,
      size: 26,
      theme: null
    };

    var me = Object(i.withTheme)(oe),
        he = function he(e) {
      var t = e.size,
          l = e.color,
          a = e.theme,
          n = e.iconTitle,
          r = l || a && a.iconColor;
      return c.a.createElement("svg", {
        viewBox: "0 0 28.42823 24.49425",
        width: t,
        height: t,
        fill: r,
        stroke: r
      }, c.a.createElement("title", null, n), c.a.createElement("g", {
        id: "Layer_2",
        "data-name": "Layer 2"
      }, c.a.createElement("g", {
        id: "Layer_2-2",
        "data-name": "Layer 2"
      }, c.a.createElement("path", {
        d: "M28.36827,23.4621a1.057,1.057,0,0,0,.02789-.13788V7.3833a1.071,1.071,0,0,0-.03491-.17255.74253.74253,0,0,0-.71472-.96319h-1.889V0H2.94889V6.24756H.78666a.7433.7433,0,0,0-.71484.96277,1.06829,1.06829,0,0,0-.035.173V23.32422a1.06048,1.06048,0,0,0,.02509.124.74775.74775,0,0,0,.98151.9856,1.05631,1.05631,0,0,0,.12915.02612H27.26042a1.06587,1.06587,0,0,0,.14917-.03021.73185.73185,0,0,0,.95868-.96765ZM24.75749,1V8.11285L14.19358,15.8255,3.94889,8.3147V1ZM13.78813,16.96875a.74926.74926,0,0,0,.85742,0L26.89616,8.4342V22.18445l-7.6261-5.895L25.85447,22.96H2.579l6.58441-6.67047L1.53678,22.18475V8.434Z"
      }))));
    };

    he.propTypes = {
      color: r.a.string,
      iconTitle: r.a.string,
      size: r.a.number,
      theme: r.a.object
    }, he.defaultProps = {
      color: null,
      iconTitle: null,
      size: 26,
      theme: null
    };

    var ue = Object(i.withTheme)(he),
        de = function de(e) {
      var t = e.size,
          l = e.color,
          a = e.theme,
          n = e.iconTitle,
          r = l || a && a.iconColor;
      return c.a.createElement("svg", {
        viewBox: "0 0 25.753 26.644",
        width: t,
        height: t
      }, c.a.createElement("title", null, n), c.a.createElement("g", {
        "data-name": "Layer 2"
      }, c.a.createElement("g", {
        "data-name": "Layer 7",
        fill: "none",
        stroke: r,
        strokeMiterlimit: 10
      }, c.a.createElement("path", {
        d: "M17.091 10.434a8.382 8.382 0 0 0 .158-1.56 8.383 8.383 0 0 0-.158-1.559h-1.72a6.635 6.635 0 0 0-.804-1.928l1.226-1.226a8.418 8.418 0 0 0-2.206-2.205l-1.225 1.226a6.636 6.636 0 0 0-1.928-.804V.658A8.382 8.382 0 0 0 8.874.5a8.383 8.383 0 0 0-1.56.157v1.721a6.634 6.634 0 0 0-1.927.804L4.16 1.956A8.418 8.418 0 0 0 1.956 4.16L3.18 5.387a6.636 6.636 0 0 0-.803 1.928H.658A8.383 8.383 0 0 0 .5 8.875a8.382 8.382 0 0 0 .157 1.559h1.721a6.637 6.637 0 0 0 .803 1.928l-1.225 1.226a8.416 8.416 0 0 0 2.205 2.205l1.226-1.226a6.633 6.633 0 0 0 1.928.803v1.722a8.384 8.384 0 0 0 1.56.157 8.383 8.383 0 0 0 1.559-.157V15.37a6.637 6.637 0 0 0 1.928-.803l1.225 1.226a8.42 8.42 0 0 0 2.206-2.205l-1.226-1.226a6.636 6.636 0 0 0 .803-1.928zM8.874 11.58a2.706 2.706 0 1 1 2.706-2.706 2.706 2.706 0 0 1-2.706 2.706z"
      }), c.a.createElement("path", {
        d: "M24.468 24.066a5.32 5.32 0 0 0 .898-1.925l-1.062-.496a4.519 4.519 0 0 0 .06-1.421l1.109-.403a5.734 5.734 0 0 0-.726-1.997l-1.11.404a4.52 4.52 0 0 0-.958-1.052l.496-1.062a5.322 5.322 0 0 0-1.925-.898l-.496 1.062a4.518 4.518 0 0 0-1.421-.06l-.403-1.11a5.733 5.733 0 0 0-1.997.727l.404 1.109a4.52 4.52 0 0 0-1.052.959l-1.062-.496a5.321 5.321 0 0 0-.898 1.925l1.062.495a4.52 4.52 0 0 0-.06 1.422l-1.11.403a5.732 5.732 0 0 0 .727 1.997l1.11-.404a4.517 4.517 0 0 0 .958 1.051l-.496 1.063a5.321 5.321 0 0 0 1.925.898l.496-1.062a4.52 4.52 0 0 0 1.42.06l.404 1.109a5.735 5.735 0 0 0 1.997-.726l-.404-1.11a4.52 4.52 0 0 0 1.051-.958zm-5.402-1.66a1.843 1.843 0 1 1 2.45-.89 1.843 1.843 0 0 1-2.45.89z",
        strokeWidth: .5
      }))));
    };

    de.propTypes = {
      color: r.a.string,
      iconTitle: r.a.string,
      size: r.a.number,
      theme: r.a.object
    }, de.defaultProps = {
      color: null,
      iconTitle: null,
      size: 26,
      theme: null
    };
    var pe = Object(i.withTheme)(de);

    function Ee() {
      var e = function (e, t) {
        t || (t = e.slice(0));
        return Object.freeze(Object.defineProperties(e, {
          raw: {
            value: Object.freeze(t)
          }
        }));
      }(["\n  .st0 {\n    display: none;\n  }\n  .st1 {\n    display: inline;\n  }\n  .st2 {\n    display: inline;\n    fill: none;\n    stroke: #000000;\n    stroke-width: 1.5;\n    stroke-linecap: round;\n    stroke-linejoin: round;\n    stroke-miterlimit: 10;\n  }\n  .st3 {\n    fill: ", ";\n  }\n  .st4 {\n    display: inline;\n    fill: #a28352;\n  }\n  .st5 {\n    fill: #231f20;\n  }\n  .st6 {\n    display: inline;\n    fill: #231f20;\n  }\n  .st7 {\n    fill: none;\n    stroke: #231f20;\n    stroke-width: 1.5;\n    stroke-linecap: round;\n    stroke-miterlimit: 10;\n  }\n  .st8 {\n    fill: #a28352;\n  }\n  .st9 {\n    display: inline;\n    fill: none;\n    stroke: #444444;\n    stroke-width: 3;\n    stroke-linecap: round;\n    stroke-miterlimit: 10;\n  }\n  .st10 {\n    display: inline;\n    fill: #facb46;\n  }\n  .st11 {\n    display: inline;\n    fill: #d0023d;\n  }\n  .st12 {\n    display: inline;\n    fill: #335c33;\n  }\n"]);

      return Ee = function Ee() {
        return e;
      }, e;
    }

    var ge = s.a.div(Ee(), function (e) {
      var t = e.color,
          l = e.theme;
      return t || l && l.iconColor;
    }),
        ve = function ve(e) {
      var t = e.size,
          l = e.iconTitle;
      return c.a.createElement(ge, null, c.a.createElement("svg", {
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        x: "0px",
        y: "0px",
        width: t,
        height: t,
        viewBox: "0 0 30 30",
        xmlSpace: "preserve"
      }, c.a.createElement("title", null, l), c.a.createElement("g", {
        id: "Layer_1",
        className: "st0"
      }, c.a.createElement("path", {
        className: "st1",
        d: "M29.2,23.9c0,0,0-0.1,0-0.1V7.9c0-0.1,0-0.1,0-0.2c0-0.1,0-0.3,0-0.4c-0.1-0.3-0.4-0.5-0.7-0.5H28H2H1.6 C1.2,6.7,1,6.9,0.9,7.3c0,0.1,0,0.3,0,0.4c0,0.1,0,0.1,0,0.2v15.9c0,0,0,0.1,0,0.1c-0.1,0.3-0.1,0.6,0.2,0.8 C1.2,25,1.6,25,1.8,24.9c0,0,0.1,0,0.1,0H28c0.1,0,0.1,0,0.1,0c0.3,0.1,0.7,0,0.9-0.2C29.2,24.5,29.3,24.2,29.2,23.9z M20.1,16.8 l6.6,6.7H3.4l6.6-6.7l-7.6,5.9V8.9l12.3,8.5c0.1,0.1,0.3,0.1,0.4,0.1s0.3,0,0.4-0.1l12.3-8.5v13.8L20.1,16.8z M26,8.2L15,16.3 L4,8.2H26z"
      }), c.a.createElement("path", {
        className: "st2",
        d: "M15,12.4"
      })), c.a.createElement("g", {
        id: "Layer_2",
        className: "st0"
      }, c.a.createElement("path", {
        className: "st2",
        d: "M15,12.4"
      }), c.a.createElement("path", {
        className: "st1",
        d: "M29.2,23.9c0,0,0-0.1,0-0.1V7.9c0-0.1,0-0.1,0-0.2c0-0.1,0-0.3,0-0.4c-0.1-0.3-0.4-0.5-0.7-0.5H28h-1.5V0.5 H3.7v6.2H2H1.6C1.2,6.7,1,6.9,0.9,7.3c0,0.1,0,0.3,0,0.4c0,0.1,0,0.1,0,0.2v15.9c0,0,0,0.1,0,0.1c-0.1,0.3-0.1,0.6,0.2,0.8 C1.2,25,1.6,25,1.8,24.9c0,0,0.1,0,0.1,0H28c0.1,0,0.1,0,0.1,0c0.3,0.1,0.7,0,0.9-0.2C29.2,24.5,29.3,24.2,29.2,23.9z M25.5,1.5 v7.1L15,16.3L4.7,8.8V1.5H25.5z M14.6,17.4c0.1,0.1,0.3,0.1,0.4,0.1s0.3,0,0.4-0.1l12.3-8.5v13.8l-7.6-5.9l6.6,6.7H3.4l6.6-6.7 l-7.6,5.9V8.9L14.6,17.4z"
      })), c.a.createElement("g", {
        id: "Layer_3",
        className: "st0"
      }, c.a.createElement("g", {
        className: "st1"
      }, c.a.createElement("path", {
        d: "M20.5,8.9c-0.4,0-0.8,0.3-0.8,0.8v14c0,0.1-0.1,0.2-0.2,0.2h-9.1c-0.1,0-0.2-0.1-0.2-0.2v-14c0-0.4-0.3-0.8-0.8-0.8 S8.8,9.3,8.8,9.7v14c0,0.9,0.7,1.7,1.7,1.7h9.1c0.9,0,1.7-0.7,1.7-1.7v-14C21.2,9.3,20.9,8.9,20.5,8.9z"
      }), c.a.createElement("path", {
        d: "M22.2,7h-3.8V6c0-1.3-1-2.3-2.3-2.3h-2.2c-1.3,0-2.3,1-2.3,2.3v1H7.8C7.4,7,7.1,7.3,7.1,7.7s0.3,0.8,0.8,0.8h14.4 c0.4,0,0.8-0.3,0.8-0.8S22.6,7,22.2,7z M13.1,6c0-0.4,0.4-0.8,0.8-0.8h2.2c0.4,0,0.8,0.4,0.8,0.8v1h-3.8V6z"
      }), c.a.createElement("path", {
        d: "M17.8,20.4v-9.2c0-0.4-0.3-0.8-0.8-0.8s-0.8,0.3-0.8,0.8v9.2c0,0.4,0.3,0.8,0.8,0.8S17.8,20.8,17.8,20.4z"
      }), c.a.createElement("path", {
        d: "M13.8,20.4v-9.2c0-0.4-0.3-0.8-0.8-0.8s-0.8,0.3-0.8,0.8v9.2c0,0.4,0.3,0.8,0.8,0.8S13.8,20.8,13.8,20.4z"
      }))), c.a.createElement("g", {
        id: "Layer_7"
      }, c.a.createElement("g", null, c.a.createElement("path", {
        className: "st3",
        d: "M10.9,19.4c-0.5,0-1.1-0.1-1.7-0.2l-0.5-0.1v-1.8c-0.4-0.1-0.8-0.3-1.2-0.5l-1.3,1.3l-0.4-0.3 c-0.9-0.6-1.7-1.4-2.4-2.4L3.1,15l1.3-1.3C4.2,13.4,4,13,3.9,12.5H2.1L2,12c-0.1-0.6-0.2-1.1-0.2-1.7c0-0.5,0.1-1.1,0.2-1.7 l0.1-0.5h1.8C4,7.8,4.2,7.4,4.4,7L3.1,5.7l0.3-0.4c0.6-0.9,1.4-1.7,2.4-2.4l0.4-0.3l1.3,1.3c0.4-0.2,0.8-0.4,1.2-0.5V1.6l0.5-0.1 c1.2-0.2,2.2-0.2,3.4,0L13,1.6v1.8c0.4,0.1,0.8,0.3,1.2,0.5l1.3-1.3l0.4,0.3c0.9,0.6,1.7,1.4,2.4,2.4l0.3,0.4L17.3,7 c0.2,0.4,0.4,0.8,0.5,1.2h1.8l0.1,0.5c0.1,0.6,0.2,1.1,0.2,1.7c0,0.5-0.1,1.1-0.2,1.7l-0.1,0.5h-1.8c-0.1,0.4-0.3,0.8-0.5,1.2 l1.3,1.3l-0.3,0.4c-0.6,0.9-1.4,1.7-2.4,2.4l-0.4,0.3l-1.3-1.3c-0.4,0.2-0.8,0.4-1.2,0.5v1.8l-0.5,0.1 C11.9,19.3,11.4,19.4,10.9,19.4z M9.9,18c0.7,0.1,1.2,0.1,1.9,0v-1.7l0.5-0.1c0.6-0.1,1.2-0.4,1.7-0.7l0.4-0.3l1.2,1.2 c0.5-0.4,0.9-0.8,1.3-1.3l-1.2-1.2l0.3-0.4c0.3-0.5,0.6-1.1,0.7-1.7l0.1-0.5h1.7c0-0.3,0.1-0.6,0.1-0.9c0-0.3,0-0.6-0.1-0.9h-1.7 l-0.1-0.5c-0.1-0.6-0.4-1.2-0.7-1.7l-0.3-0.4L17,5.6c-0.4-0.5-0.8-0.9-1.3-1.3l-1.2,1.2L14,5.2c-0.5-0.3-1.1-0.6-1.7-0.7l-0.5-0.1 V2.7c-0.7-0.1-1.2-0.1-1.9,0v1.7L9.4,4.5C8.8,4.6,8.2,4.9,7.7,5.2L7.3,5.5L6.1,4.3C5.6,4.6,5.1,5.1,4.8,5.6L6,6.8L5.7,7.2 C5.4,7.7,5.1,8.3,5,8.9L4.9,9.4H3.2c0,0.3-0.1,0.6-0.1,0.9c0,0.3,0,0.6,0.1,0.9h1.7L5,11.8c0.1,0.6,0.4,1.2,0.7,1.7L6,13.9 l-1.2,1.2c0.4,0.5,0.8,0.9,1.3,1.3l1.2-1.2l0.4,0.3c0.5,0.3,1.1,0.6,1.7,0.7l0.5,0.1V18z M10.9,13.7c-1.8,0-3.3-1.5-3.3-3.3 S9,7,10.9,7c1.8,0,3.3,1.5,3.3,3.3S12.7,13.7,10.9,13.7z M10.9,8.3c-1.1,0-2.1,0.9-2.1,2.1s0.9,2.1,2.1,2.1s2.1-0.9,2.1-2.1 S12,8.3,10.9,8.3z"
      })), c.a.createElement("g", null, c.a.createElement("path", {
        className: "st3",
        d: "M22.5,28.3l-0.4-1.1c-0.3,0-0.6,0-0.9,0l-0.5,1.1l-0.3-0.1c-0.4-0.1-0.8-0.2-1.1-0.4c-0.3-0.1-0.6-0.3-1-0.6 L18,27l0.5-1.1c-0.2-0.2-0.4-0.4-0.6-0.7l-1.1,0.4l-0.2-0.3c-0.4-0.7-0.7-1.4-0.8-2.1l0-0.3l1.1-0.4c0-0.3,0-0.6,0-0.9L15.9,21 l0.1-0.3c0.1-0.4,0.2-0.8,0.4-1.1c0.2-0.3,0.3-0.6,0.6-1l0.2-0.3l1.1,0.5c0.2-0.2,0.4-0.4,0.7-0.6l-0.4-1.1l0.3-0.2 c0.7-0.4,1.4-0.7,2.1-0.8l0.3,0l0.4,1.1c0.3,0,0.6,0,0.9,0l0.5-1.1l0.3,0.1c0.4,0.1,0.7,0.2,1.1,0.4c0.3,0.2,0.6,0.3,1,0.6 l0.3,0.2l-0.5,1.1c0.2,0.2,0.4,0.4,0.6,0.7l1.1-0.4l0.2,0.3c0.4,0.7,0.6,1.4,0.8,2.1l0,0.3L26.7,22c0,0.3,0,0.6,0,0.9l1.1,0.5 l-0.1,0.3c-0.1,0.4-0.2,0.7-0.4,1.1c-0.2,0.3-0.3,0.6-0.6,1L26.6,26l-1.1-0.5c-0.2,0.2-0.4,0.4-0.7,0.6l0.4,1.1l-0.3,0.2 c-0.7,0.4-1.4,0.7-2.1,0.8L22.5,28.3z M22.6,26.3l0.4,1.1c0.5-0.1,0.9-0.3,1.3-0.5l-0.4-1.1l0.2-0.2c0.4-0.2,0.7-0.5,1-0.9 l0.2-0.2l1,0.5c0.1-0.2,0.2-0.4,0.3-0.6c0.1-0.2,0.2-0.4,0.2-0.6l-1-0.5l0.1-0.3c0.1-0.4,0.1-0.9,0.1-1.3l0-0.3l1.1-0.4 c-0.1-0.4-0.3-0.9-0.5-1.3l-1.1,0.4l-0.2-0.2c-0.2-0.4-0.5-0.7-0.9-1l-0.2-0.2l0.5-1c-0.2-0.1-0.4-0.2-0.6-0.3 c-0.2-0.1-0.4-0.2-0.6-0.2l-0.5,1l-0.3-0.1c-0.4-0.1-0.9-0.1-1.3-0.1l-0.3,0L20.7,17c-0.5,0.1-0.9,0.3-1.3,0.5l0.4,1.1l-0.2,0.2 c-0.4,0.2-0.7,0.5-1,0.9l-0.2,0.2l-1-0.5c-0.1,0.2-0.2,0.4-0.3,0.6c-0.1,0.2-0.2,0.4-0.2,0.6l1,0.5l-0.1,0.3 c-0.1,0.4-0.1,0.9-0.1,1.3l0,0.3l-1.1,0.4c0.1,0.5,0.3,0.9,0.5,1.3l1.1-0.4l0.2,0.2c0.2,0.4,0.5,0.7,0.9,1l0.2,0.2l-0.5,1 c0.2,0.1,0.4,0.2,0.6,0.3c0.2,0.1,0.4,0.2,0.6,0.2l0.5-1l0.3,0.1c0.4,0.1,0.9,0.1,1.3,0.1L22.6,26.3z M21.8,24.4 c-0.3,0-0.6-0.1-0.9-0.2c-1.1-0.5-1.6-1.8-1.1-2.9c0.3-0.5,0.7-0.9,1.3-1.1c0.6-0.2,1.2-0.2,1.7,0.1c0.5,0.3,0.9,0.7,1.1,1.3 c0.2,0.6,0.2,1.2-0.1,1.7c-0.2,0.5-0.7,0.9-1.3,1.1C22.3,24.4,22.1,24.4,21.8,24.4z M21.8,20.8c-0.6,0-1.1,0.3-1.3,0.8 c-0.3,0.7,0,1.6,0.7,2h0c0.4,0.2,0.8,0.2,1.1,0c0.4-0.1,0.7-0.4,0.8-0.8c0.2-0.4,0.2-0.8,0-1.1c-0.1-0.4-0.4-0.7-0.8-0.8 C22.3,20.8,22,20.8,21.8,20.8z"
      }))), c.a.createElement("g", {
        id: "Layer_4",
        className: "st0"
      }, c.a.createElement("path", {
        className: "st4",
        d: "M-4.3-18.8c-13.6,0-24.6,11-24.6,24.6s11,24.6,24.6,24.6s24.6-11,24.6-24.6S9.3-18.8-4.3-18.8z M-8.7,14.3 c-1.5,0-2.9,0-4.4,0c0-4.4,0-8.7,0-13.1c1.4,0,2.9,0,4.4,0C-8.7,5.5-8.7,9.9-8.7,14.3z M-9.4-1c-1.1,0.7-3.5,0.6-3.9-1.4 c0-0.1-0.1-0.1-0.1-0.2c0-0.3,0-0.6,0-0.8c0.9-1.8,2.5-2.4,3.9-1.6C-8.1-4.1-8-1.9-9.4-1z M6.9,14.3c-0.7,0-1.4,0-2.1,0 c-0.7,0-1.4,0-2.2,0c0-0.3,0-0.6,0-0.9c0-2.3,0-4.6-0.1-6.9C2.4,5.1,1.6,4.3,0.3,4.3c-1.3,0-2.3,1.1-2.3,2.4c0,2.5,0,4.9,0,7.5 c-1.5,0-2.9,0-4.4,0c0-4.4,0-8.7,0-13.1c1.5,0,2.9,0,4.4,0c0,0.5,0,1,0,1.6c0.8-1,1.6-1.6,2.7-1.9c3.1-0.7,5.8,1.1,6.1,4.4 C7.1,8.2,6.9,11.2,6.9,14.3z"
      })), c.a.createElement("g", {
        id: "Layer_6",
        className: "st0"
      }, c.a.createElement("g", {
        className: "st1"
      }, c.a.createElement("path", {
        className: "st5",
        d: "M15,28.4c-7.4,0-13.4-6-13.4-13.4S7.6,1.6,15,1.6s13.4,6,13.4,13.4S22.4,28.4,15,28.4z M15,3.1 C8.4,3.1,3.1,8.4,3.1,15S8.4,26.9,15,26.9S26.9,21.6,26.9,15S21.6,3.1,15,3.1z"
      })), c.a.createElement("path", {
        className: "st6",
        d: "M24.6,12.8c-0.1-0.4-0.5-0.7-0.9-0.6L15.8,14c-0.2-0.2-0.5-0.3-0.8-0.3c-0.7,0-1.3,0.6-1.3,1.3 c0,0.1,0,0.1,0,0.2L9,20.3c-0.3,0.3-0.3,0.8,0,1.1c0.1,0.1,0.3,0.2,0.5,0.2c0.2,0,0.4-0.1,0.5-0.2l4.8-5.1c0,0,0.1,0,0.1,0 c0.5,0,1-0.3,1.2-0.8l7.9-1.8C24.4,13.6,24.7,13.2,24.6,12.8z"
      }), c.a.createElement("g", {
        className: "st1"
      }, c.a.createElement("path", {
        className: "st7",
        d: "M42.9,18.3"
      }))), c.a.createElement("g", {
        id: "Layer_5",
        className: "st0"
      }, c.a.createElement("path", {
        className: "st4",
        d: "M-3.9-18.8c-13.6,0-24.6,11-24.6,24.6s11,24.6,24.6,24.6s24.6-11,24.6-24.6S9.7-18.8-3.9-18.8z M2.9-3.6H0.5 c-2,0-2.3,1.2-2.3,2.5v2.8h4.7L2.2,7h-4.1v11.8h-4.7V7h-4.1V1.7h4.1v-3.2c0-4.1,2.3-6.3,5.9-6.3c1.7,0,2.9,0.1,3.5,0.2V-3.6z"
      })), c.a.createElement("g", {
        id: "Layer_8",
        className: "st0"
      }, c.a.createElement("g", {
        className: "st1"
      }, c.a.createElement("path", {
        className: "st8",
        d: "M104.6,21.3H17.4v-49.9h87.2V21.3z M21.9,16.9h78.3v-41H21.9V16.9z"
      })), c.a.createElement("g", {
        className: "st1"
      }, c.a.createElement("path", {
        className: "st8",
        d: "M61,12.9c-9.1,0-16.6-7.4-16.6-16.6c0-9.1,7.4-16.6,16.6-16.6s16.6,7.4,16.6,16.6C77.6,5.5,70.1,12.9,61,12.9 z M61-18c-7.9,0-14.3,6.4-14.3,14.3c0,7.9,6.4,14.3,14.3,14.3S75.4,4.3,75.4-3.6C75.4-11.6,68.9-18,61-18z"
      })), c.a.createElement("g", {
        className: "st1"
      }, c.a.createElement("rect", {
        x: "27.3",
        y: "-19.7",
        className: "st8",
        width: "9",
        height: "2.2"
      })), c.a.createElement("g", {
        className: "st1"
      }, c.a.createElement("rect", {
        x: "87.2",
        y: "-19.7",
        className: "st8",
        width: "9",
        height: "2.2"
      })), c.a.createElement("g", {
        className: "st1"
      }, c.a.createElement("rect", {
        x: "27.3",
        y: "10.7",
        className: "st8",
        width: "9",
        height: "2.2"
      })), c.a.createElement("g", {
        className: "st1"
      }, c.a.createElement("rect", {
        x: "87.2",
        y: "10.7",
        className: "st8",
        width: "9",
        height: "2.2"
      })), c.a.createElement("g", {
        className: "st1"
      }, c.a.createElement("polygon", {
        className: "st8",
        points: "-62.5,-14.2 -60,-14.2 -60,-21.6 -52.6,-21.6 -52.6,-24.1 -60,-24.1 -60,-31.5 -62.5,-31.5 -62.5,-24.1 -69.9,-24.1 -69.9,-21.6 -62.5,-21.6 \t\t"
      }), c.a.createElement("polygon", {
        className: "st8",
        points: "-56,0.9 -61.2,6.1 -66.5,0.9 -68.2,2.6 -63,7.9 -68.2,13.1 -66.5,14.8 -61.2,9.6 -56,14.8 -54.2,13.1 -59.5,7.9 -54.2,2.6 \t\t"
      }), c.a.createElement("rect", {
        x: "-42.9",
        y: "6.6",
        transform: "matrix(0.707 -0.7072 0.7072 0.707 -15.5724 -21.8866)",
        className: "st8",
        width: "17.3",
        height: "2.5"
      }), c.a.createElement("rect", {
        x: "-42.9",
        y: "-24.1",
        className: "st8",
        width: "17.3",
        height: "2.5"
      }), c.a.createElement("path", {
        className: "st8",
        d: "M-84.2-42.5v72.1h72.1v-72.1H-84.2z M-17,24.7h-62.3v-62.3H-17V24.7z"
      }), c.a.createElement("circle", {
        className: "st8",
        cx: "-39.5",
        cy: "2.5",
        r: "2.1"
      }), c.a.createElement("path", {
        className: "st8",
        d: "M-28.7,11.4c-1.1,0-1.9,0.9-1.9,1.9c0,1.1,0.9,1.9,1.9,1.9c1.1,0,1.9-0.9,1.9-1.9 C-26.8,12.2-27.7,11.4-28.7,11.4z"
      })), c.a.createElement("g", {
        className: "st1"
      }, c.a.createElement("polygon", {
        className: "st8",
        points: "-123.9,24.7 -123.9,19.4 -126.3,19.4 -126.3,24.7 -133.7,24.7 -133.7,19.4 -136.1,19.4 -136.1,24.7 -143.5,24.7 -143.5,19.4 -146,19.4 -146,24.7 -153.4,24.7 -153.4,19.4 -155.8,19.4 -155.8,24.7 -163.2,24.7 -163.2,19.4 -165.6,19.4 -165.6,24.7 -177.6,24.7 -177.6,14.2 -173.3,14.2 -173.3,11.7 -177.6,11.7 -177.6,4.3 -173.3,4.3 -173.3,1.9 -177.6,1.9 -177.6,-5.5 -173.3,-5.5 -173.3,-7.9 -177.6,-7.9 -177.6,-15.3 -173.3,-15.3 -173.3,-17.8 -177.6,-17.8 -177.6,-25.1 -173.3,-25.1 -173.3,-27.6 -177.6,-27.6 -177.6,-40.1 -182.5,-40.1 -182.5,29.6 -112.8,29.6 -112.8,24.7 \t\t"
      }), c.a.createElement("path", {
        className: "st8",
        d: "M-155.2-11.9h-10.2v26h10.2V-11.9z M-157.7,11.7h-5.3V-9.4h5.3V11.7z"
      }), c.a.createElement("path", {
        className: "st8",
        d: "M-138.7-29.1h-10.2v43.2h10.2V-29.1z M-141.2,11.7h-5.3v-38.3h5.3V11.7z"
      }), c.a.createElement("path", {
        className: "st8",
        d: "M-122.2-19.2h-10.2v33.4h10.2V-19.2z M-124.7,11.7h-5.3v-28.5h5.3V11.7z"
      })), c.a.createElement("g", {
        className: "st1"
      }, c.a.createElement("path", {
        className: "st8",
        d: "M-215.2,15.6v-48h-23.4l0,0l-11-7.7l-11,7.7l0,0H-284v48h33.6v11.1h-8.4V30h18.5v-3.3h-8.4V15.6H-215.2z M-249.6-38.2l8.3,5.8h-16.6L-249.6-38.2z M-279.9-28.3h60.5v39.7h-60.5V-28.3z"
      }), c.a.createElement("path", {
        className: "st8",
        d: "M-244.9-22.5l-0.8,0.2c-3.5,1-6.1,3.9-6.8,7.4l-0.1,0.8l10.6,2.7L-244.9-22.5z M-246-20.4l1.7,6.7l-6.4-1.6 C-250-17.6-248.3-19.5-246-20.4z"
      }), c.a.createElement("path", {
        className: "st8",
        d: "M-238.5-20.9c-0.8,0-1.6,0.1-2.5,0.3l0,0l-0.6,0.2c-0.3,0.1-0.7,0.2-1,0.3c0,0,0,0,0,0c0,0,0,0,0,0l0.3,0.7 l0,0l2.7,10.5l-10.8-2.8l-0.2,0.9c0,0,0,0,0,0l0,0c-0.1,0.8-0.2,1.5-0.2,2.2c0,6.8,5.5,12.3,12.3,12.3c6.8,0,12.3-5.5,12.3-12.3 S-231.7-20.9-238.5-20.9z M-238.5,2c-5.9,0-10.6-4.8-10.6-10.6c0-0.3,0-0.7,0.1-1l11.7,3l-3.2-12.4c0.7-0.1,1.4-0.2,2-0.2 c5.9,0,10.6,4.8,10.6,10.6S-232.6,2-238.5,2z"
      }), c.a.createElement("rect", {
        x: "-272.9",
        y: "-16.9",
        className: "st8",
        width: "15.8",
        height: "1.6"
      }), c.a.createElement("rect", {
        x: "-272.9",
        y: "-10.3",
        className: "st8",
        width: "12.5",
        height: "1.6"
      }), c.a.createElement("rect", {
        x: "-272.9",
        y: "-3.7",
        className: "st8",
        width: "7.6",
        height: "1.6"
      }))), c.a.createElement("g", {
        id: "simi",
        className: "st0"
      }, c.a.createElement("g", {
        className: "st1"
      }, c.a.createElement("path", {
        d: "M18.5,2.7h-7.1C9.9,2.7,8.6,4,8.6,5.6v19.1c0,1.6,1.3,2.9,2.9,2.9h7.1c1.6,0,2.9-1.3,2.9-2.9V5.6 C21.4,4,20.1,2.7,18.5,2.7z M10.1,7.8h9.9v13.8h-9.9V7.8z M11.5,4.2h7.1c0.8,0,1.4,0.6,1.4,1.4v1.2h-9.9V5.6 C10.1,4.8,10.7,4.2,11.5,4.2z M18.5,26.1h-7.1c-0.8,0-1.4-0.6-1.4-1.4v-2.1h9.9v2.1C19.9,25.5,19.3,26.1,18.5,26.1z"
      })), c.a.createElement("g", {
        className: "st1"
      }, c.a.createElement("path", {
        d: "M15,25.2c-0.5,0-0.8-0.4-0.9-0.8l0,0c0-0.5,0.3-0.9,0.8-0.9c0.2,0,0.5,0.1,0.6,0.2c0.2,0.2,0.3,0.4,0.3,0.6 C15.9,24.8,15.6,25.2,15,25.2C15,25.2,15,25.2,15,25.2z M14.6,24.4c0,0.2,0.2,0.4,0.4,0.4c0.2,0,0.4-0.2,0.4-0.4 c0-0.1-0.1-0.2-0.1-0.3S15.1,24,15,24C14.8,24,14.6,24.2,14.6,24.4L14.6,24.4z"
      }))), c.a.createElement("g", {
        id: "hus",
        className: "st0"
      }, c.a.createElement("g", {
        className: "st1"
      }, c.a.createElement("path", {
        d: "M25.9,27.8h-9.1v-8h-3.6v8H4.1V16.4L1,14.8L15,2.5l14,12.3l-3.1,1.5V27.8z M18.6,26h5.6V15.3l1.7-0.8L15,4.9L4.2,14.4 l1.7,0.8V26h5.6v-8h7.1V26z"
      }))), c.a.createElement("g", {
        id: "las",
        className: "st0"
      }, c.a.createElement("path", {
        className: "st1",
        d: "M24.8,12.8h-1.3V9.3c0-4.7-3.8-8.4-8.4-8.4S6.6,4.6,6.6,9.3v3.6H5.2c-0.9,0-1.6,0.7-1.6,1.6v13.1 c0,0.9,0.7,1.6,1.6,1.6h19.6c0.9,0,1.6-0.7,1.6-1.6V14.4C26.4,13.6,25.7,12.8,24.8,12.8z M8.4,9.3c0-3.6,3-6.6,6.6-6.6 s6.6,3,6.6,6.6v3.6H8.4V9.3z M24.5,27.3h-19V14.7h1.1h16.9h1.1V27.3z"
      }), c.a.createElement("path", {
        className: "st1",
        d: "M16.8,19.2c0-1-0.8-1.8-1.8-1.8s-1.8,0.8-1.8,1.8c0,0.7,0.4,1.2,0.9,1.5l-0.9,3.4h3.5l-0.8-3.4 C16.4,20.4,16.8,19.9,16.8,19.2z"
      })), c.a.createElement("g", {
        id: "quit",
        className: "st0"
      }, c.a.createElement("g", {
        className: "st1"
      }, c.a.createElement("path", {
        d: "M15.5,28.6c-7,0-12.7-5.7-12.7-12.7c0-4.6,2.5-8.9,6.6-11.2l1,1.7c-3.4,1.9-5.5,5.5-5.5,9.4c0,5.9,4.8,10.7,10.7,10.7 c5.9,0,10.7-4.8,10.7-10.7c0-3.8-2.1-7.4-5.4-9.3l1-1.7c3.9,2.3,6.4,6.5,6.4,11C28.3,22.9,22.5,28.6,15.5,28.6z"
      })), c.a.createElement("g", {
        className: "st1"
      }, c.a.createElement("rect", {
        x: "14.5",
        y: "2.6",
        width: "2",
        height: "12.4"
      }))), c.a.createElement("g", {
        id: "pdf",
        className: "st0"
      }, c.a.createElement("g", {
        id: "Layer_2_1_",
        className: "st1"
      }, c.a.createElement("g", {
        id: "Layer_1-2"
      }, c.a.createElement("g", {
        id: "Layer_1-3"
      }, c.a.createElement("g", {
        id: "Layer_2-2"
      }, c.a.createElement("g", {
        id: "Layer_1-2-2"
      }, c.a.createElement("g", {
        id: "Layer_3_1_"
      }, c.a.createElement("polygon", {
        className: "st8",
        points: "20.5,22.9 20.5,25 5.8,25 5.8,5 17.1,5 17.1,8.3 20.5,8.3 20.5,12.2 21.8,12.2 21.8,7.6 17.8,3.7 4.4,3.7 4.4,26.3 21.8,26.3 21.8,22.9 \t\t\t\t\t\t\t"
      }), c.a.createElement("path", {
        className: "st8",
        d: "M12,16.2c-0.3,0-0.4,0-0.4,0.1v1.5H12c0.6,0,1-0.3,1-0.8S12.6,16.2,12,16.2z"
      }), c.a.createElement("path", {
        className: "st8",
        d: "M16.5,16.2c-0.3,0-0.4,0-0.5,0.1v3.3h0.4c0.8,0.1,1.6-0.5,1.7-1.3c0-0.1,0-0.1,0-0.2v-0.3 c0.1-0.8-0.5-1.5-1.3-1.6c0,0,0,0,0,0H16.5z"
      }), c.a.createElement("path", {
        className: "st8",
        d: "M7.6,13v9h17.9v-9L7.6,13z M13.6,18.1c-0.5,0.4-1.1,0.6-1.7,0.5h-0.3v1.8h-1.2v-5.1 c0.5-0.1,1-0.1,1.5-0.1c0.5,0,1.1,0.1,1.5,0.4c0.4,0.3,0.6,0.7,0.6,1.2C14.2,17.3,14,17.8,13.6,18.1z M18.5,19.8 c-0.7,0.5-1.6,0.7-2.4,0.6c-0.6,0-1-0.1-1.3-0.1v-5c0.5-0.1,1-0.1,1.5-0.1c0.7-0.1,1.5,0.2,2.1,0.6c0.6,0.4,0.9,1.2,0.8,1.9 C19.5,18.5,19.2,19.3,18.5,19.8z M23.2,16.2h-2v1.2h1.9v1h-1.9v2H20v-5.1h3.1L23.2,16.2z"
      }))))))), c.a.createElement("line", {
        className: "st9",
        x1: "-94.1",
        y1: "-117",
        x2: "-74.8",
        y2: "-97.7"
      }), c.a.createElement("line", {
        className: "st9",
        x1: "-74.8",
        y1: "-117",
        x2: "-94.1",
        y2: "-97.7"
      })), c.a.createElement("g", {
        id: "new_window",
        className: "st0"
      }, c.a.createElement("g", {
        className: "st1"
      }, c.a.createElement("path", {
        className: "st8",
        d: "M22.7,26.6H3.5V7.4h6.6c0.6,0,1,0.4,1,1s-0.4,1-1,1H5.5v15.2h15.2v-4.9c0-0.6,0.4-1,1-1s1,0.4,1,1V26.6z"
      })), c.a.createElement("path", {
        className: "st4",
        d: "M14.9,8.3L14.9,8.3C15,8.7,15.3,9,15.7,9l3.9,0l-7.4,7.6c-0.3,0.3-0.3,0.8,0,1.1c0.2,0.1,0.3,0.2,0.5,0.2 c0.2,0,0.4-0.1,0.6-0.2l7.5-7.6l0.1,3.9c0,0.4,0.4,0.7,0.8,0.8h0c0.5,0,0.8-0.4,0.8-0.8l-0.1-6.7l-6.7,0.1 C15.3,7.5,14.9,7.8,14.9,8.3z"
      })), c.a.createElement("g", {
        id: "Layer_15",
        className: "st0"
      }, c.a.createElement("g", {
        className: "st1"
      }, c.a.createElement("path", {
        className: "st8",
        d: "M26.2,25.1h-22V5.8h22V25.1z M6.3,23.1h18V7.8h-18V23.1z"
      })), c.a.createElement("circle", {
        className: "st4",
        cx: "20",
        cy: "12.1",
        r: "1.3"
      }), c.a.createElement("polygon", {
        className: "st4",
        points: "12.8,12.9 16.6,17.8 18.3,16.4 22.1,20.7 7.8,20.7 \t"
      })), c.a.createElement("g", {
        id: "Layer_15_copy",
        className: "st0"
      }, c.a.createElement("g", {
        className: "st1"
      }, c.a.createElement("path", {
        className: "st8",
        d: "M23.2,5.8V2.8h-2v2.9h-12V2.8h-2v2.9h-3v19.3h22V5.8H23.2z M24.2,23.1h-18V7.8h18V23.1z"
      }), c.a.createElement("rect", {
        x: "9",
        y: "12.8",
        className: "st8",
        width: "2.7",
        height: "2.7"
      }), c.a.createElement("rect", {
        x: "14",
        y: "12.8",
        className: "st8",
        width: "2.7",
        height: "2.7"
      }), c.a.createElement("rect", {
        x: "19",
        y: "12.8",
        className: "st8",
        width: "2.7",
        height: "2.7"
      }), c.a.createElement("rect", {
        x: "9",
        y: "17.8",
        className: "st8",
        width: "2.7",
        height: "2.7"
      }), c.a.createElement("rect", {
        x: "14",
        y: "17.8",
        className: "st8",
        width: "2.7",
        height: "2.7"
      }), c.a.createElement("rect", {
        x: "19",
        y: "17.8",
        className: "st8",
        width: "2.7",
        height: "2.7"
      }))), c.a.createElement("g", {
        id: "upphropun",
        className: "st0"
      }, c.a.createElement("path", {
        className: "st10",
        d: "M15,19.6L15,19.6c-0.7,0-1.3-0.5-1.4-1.2L12.2,4.6c-0.1-1.7,1.2-3.1,2.9-3.1h0c1.7,0,3,1.4,2.9,3.1l-1.6,13.8 C16.3,19.1,15.7,19.6,15,19.6z"
      }), c.a.createElement("circle", {
        className: "st10",
        cx: "15.1",
        cy: "25.9",
        r: "2.6"
      })), c.a.createElement("g", {
        id: "x",
        className: "st0"
      }, c.a.createElement("path", {
        className: "st11",
        d: "M17.6,14.7l10-10c0.8-0.8,0.8-2,0-2.8c-0.8-0.8-2-0.8-2.8,0l-10,10l-10-10c-0.8-0.8-2-0.8-2.8,0 c-0.8,0.8-0.8,2,0,2.8l10,10l-10,10c-0.8,0.8-0.8,2,0,2.8c0.4,0.4,0.9,0.6,1.4,0.6s1-0.2,1.4-0.6l10-10l10,10 c0.4,0.4,0.9,0.6,1.4,0.6s1-0.2,1.4-0.6c0.8-0.8,0.8-2,0-2.8L17.6,14.7z"
      })), c.a.createElement("g", {
        id: "Layer_19",
        className: "st0"
      }, c.a.createElement("g", {
        className: "st1"
      }, c.a.createElement("path", {
        className: "st8",
        d: "M20.5,4.4h-11c-2.8,0-5.1,2.3-5.1,5.1v11c0,2.8,2.3,5.1,5.1,5.1h11c2.8,0,5.1-2.3,5.1-5.1v-11 C25.6,6.7,23.3,4.4,20.5,4.4z M23.6,20.5c0,1.7-1.4,3.1-3.1,3.1h-11c-1.7,0-3.1-1.4-3.1-3.1v-11c0-1.7,1.4-3.1,3.1-3.1h11 c1.7,0,3.1,1.4,3.1,3.1V20.5z"
      }), c.a.createElement("polygon", {
        className: "st8",
        points: "16,10.9 14,10.9 14,14 10.9,14 10.9,16 14,16 14,19.1 16,19.1 16,16 19.1,16 19.1,14 16,14 \t\t"
      }))), c.a.createElement("g", {
        id: "Layer_20",
        className: "st0"
      }, c.a.createElement("path", {
        className: "st12",
        d: "M26.4,6.1l-3.9-3.9c-0.6-0.6-1.7-0.6-2.3,0L5.9,16.7l-1.5,7.7l7.7-1.5L26.4,8.4c0.3-0.3,0.5-0.7,0.5-1.1 C26.9,6.8,26.7,6.4,26.4,6.1z M11.2,21.2L8,21.8l-1.2-1.2l0.6-3.2L18.7,6.3l1.6,1.6L9.6,18.6l0.5,0.5L20.8,8.4l1.5,1.5L11.2,21.2z M22.9,9.4l-3.7-3.7l2.2-2.2l3.7,3.7L22.9,9.4z"
      }))));
    };

    ve.propTypes = {
      iconTitle: r.a.string,
      size: r.a.number
    }, ve.defaultProps = {
      iconTitle: null,
      size: 26
    };

    var fe = Object(i.withTheme)(ve),
        ze = function ze(e) {
      var t = e.size,
          l = e.color,
          a = e.theme,
          n = e.iconTitle,
          r = l || a && a.iconColor;
      return c.a.createElement("svg", {
        viewBox: "0 0 15.85938 21.58789",
        width: t,
        height: t
      }, c.a.createElement("title", null, n), c.a.createElement("g", {
        id: "Layer_2",
        "data-name": "Layer 2"
      }, c.a.createElement("g", {
        id: "trash",
        "data-name": "Layer 3",
        fill: r
      }, c.a.createElement("path", {
        d: "M13.40723,5.21289a.75019.75019,0,0,0-.75.75V19.93066a.15713.15713,0,0,1-.15723.15723H3.35938a.15754.15754,0,0,1-.15772-.15723V5.96289a.75.75,0,1,0-1.5,0V19.93066a1.65918,1.65918,0,0,0,1.65772,1.65723H12.5a1.65877,1.65877,0,0,0,1.65723-1.65723V5.96289A.7502.7502,0,0,0,13.40723,5.21289Z"
      }), c.a.createElement("path", {
        d: "M15.10938,3.24707H11.30957v-.9624A2.28684,2.28684,0,0,0,9.02539,0H6.834A2.28726,2.28726,0,0,0,4.54932,2.28467v.9624H.75a.75.75,0,0,0,0,1.5H15.10938a.75.75,0,0,0,0-1.5Zm-9.06006-.9624A.78562.78562,0,0,1,6.834,1.5H9.02539a.7852.7852,0,0,1,.78418.78467v.9624H6.04932Z"
      }), c.a.createElement("path", {
        d: "M10.67969,16.64941V7.43555a.75.75,0,1,0-1.5,0v9.21386a.75.75,0,0,0,1.5,0Z"
      }), c.a.createElement("path", {
        d: "M6.67969,16.64941V7.43555a.75.75,0,0,0-1.5,0v9.21386a.75.75,0,0,0,1.5,0Z"
      }))));
    };

    ze.propTypes = {
      color: r.a.string,
      iconTitle: r.a.string,
      size: r.a.number,
      theme: r.a.object
    }, ze.defaultProps = {
      color: null,
      iconTitle: null,
      size: 26,
      theme: null
    };

    var we = Object(i.withTheme)(ze),
        ye = function ye(e) {
      var t = e.size,
          l = e.color,
          a = e.theme,
          n = e.iconTitle,
          r = l || a && a.iconColor;
      return c.a.createElement("svg", {
        viewBox: "0 0 28.42819 18.24669",
        width: t,
        height: t,
        stroke: r,
        fill: r
      }, c.a.createElement("title", null, n), c.a.createElement("g", {
        id: "Layer_2",
        "data-name": "Layer 2"
      }, c.a.createElement("g", {
        id: "Layer_1-2",
        "data-name": "Layer 1"
      }, c.a.createElement("path", {
        d: "M28.36847,17.21509a1.05629,1.05629,0,0,0,.028-.13843V1.13574a1.06876,1.06876,0,0,0-.0351-.17352.74651.74651,0,0,0,.00092-.43683A.75055.75055,0,0,0,27.64649,0H.78662a.74321.74321,0,0,0-.7149.9624,1.06662,1.06662,0,0,0-.0351.17334V17.07666a1.0628,1.0628,0,0,0,.02515.12415.74773.74773,0,0,0,.98151.98547,1.05536,1.05536,0,0,0,.12909.02612H27.26074a1.06184,1.06184,0,0,0,.14893-.03015.73183.73183,0,0,0,.9588-.96716ZM19.27,10.04193l6.58441,6.67047H2.57892l6.58441-6.67047L1.53662,15.93732V2.18634l12.25147,8.53485a.74926.74926,0,0,0,.85742,0l12.251-8.53479V15.93713ZM25.25781,1.5,14.19354,9.57794,3.1753,1.5Z"
      }))));
    };

    ye.propTypes = {
      color: r.a.string,
      iconTitle: r.a.string,
      size: r.a.number,
      theme: r.a.object
    }, ye.defaultProps = {
      color: null,
      iconTitle: null,
      size: 26,
      theme: null
    };

    var Le = Object(i.withTheme)(ye),
        Me = function Me(e) {
      var t = e.size,
          l = e.color,
          a = e.theme,
          n = e.iconTitle,
          r = l || a && a.iconColor;
      return c.a.createElement("svg", {
        width: t,
        height: t,
        viewBox: "0 0 24 24",
        color: r,
        fill: r
      }, c.a.createElement("title", null, n), c.a.createElement("path", {
        fill: "none",
        d: "M0 0h24v24H0V0z"
      }), c.a.createElement("g", null, c.a.createElement("path", {
        d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zM7.07 18.28c.43-.9 3.05-1.78 4.93-1.78s4.51.88 4.93 1.78C15.57 19.36 13.86 20 12 20s-3.57-.64-4.93-1.72zm11.29-1.45c-1.43-1.74-4.9-2.33-6.36-2.33s-4.93.59-6.36 2.33A7.95 7.95 0 0 1 4 12c0-4.41 3.59-8 8-8s8 3.59 8 8c0 1.82-.62 3.49-1.64 4.83z"
      }), c.a.createElement("path", {
        d: "M12 6c-1.94 0-3.5 1.56-3.5 3.5S10.06 13 12 13s3.5-1.56 3.5-3.5S13.94 6 12 6zm0 5c-.83 0-1.5-.67-1.5-1.5S11.17 8 12 8s1.5.67 1.5 1.5S12.83 11 12 11z"
      })));
    };

    Me.propTypes = {
      color: r.a.string,
      iconTitle: r.a.string,
      size: r.a.number,
      theme: r.a.object
    }, Me.defaultProps = {
      color: null,
      iconTitle: null,
      size: 26,
      theme: null
    };

    var Ne = Object(i.withTheme)(Me),
        Ce = function Ce(e) {
      var t = e.size,
          l = e.color,
          a = e.theme,
          n = e.iconTitle,
          r = l || a && a.iconColor;
      return c.a.createElement("svg", {
        width: t,
        height: t,
        viewBox: "0 0 36 36",
        color: r,
        fill: r
      }, c.a.createElement("title", null, n), c.a.createElement("g", {
        fill: "none",
        fillRule: "evenodd",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        stroke: "#FACB46",
        strokeWidth: 3
      }, c.a.createElement("circle", {
        cx: 18,
        cy: 18,
        r: 18
      }), c.a.createElement("path", {
        d: "M18 10.8V18M18 25.2h.018"
      })));
    };

    Ce.propTypes = {
      color: r.a.string,
      iconTitle: r.a.string,
      size: r.a.number,
      theme: r.a.object
    }, Ce.defaultProps = {
      color: null,
      iconTitle: null,
      size: 26,
      theme: null
    };

    var Te = Object(i.withTheme)(Ce),
        xe = function xe(e) {
      var t = e.size,
          l = e.color,
          a = e.theme,
          n = e.iconTitle,
          r = l || a && a.iconColor;
      return c.a.createElement("svg", {
        viewBox: "0 0 16 17",
        width: t,
        height: t,
        color: r,
        fill: r
      }, c.a.createElement("title", null, n), c.a.createElement("defs", null, c.a.createElement("path", {
        d: "M8.6,10.7399194 L7.04418605,10.7399194 C7.04883723,10.2815837 7.08604616,9.89594691 7.15581395,9.58299731 C7.22558174,9.27004772 7.34302243,8.98544035 7.50813953,8.72916667 C7.67325664,8.47289298 7.89302188,8.20183835 8.16744186,7.91599462 C8.38139642,7.69914766 8.57441774,7.49339255 8.74651163,7.29872312 C8.91860551,7.10405369 9.05581344,6.89706651 9.15813953,6.67775538 C9.26046563,6.45844424 9.31162791,6.2058706 9.31162791,5.92002688 C9.31162791,5.60954146 9.26279119,5.34587922 9.16511628,5.12903226 C9.06744137,4.9121853 8.92441955,4.74708838 8.73604651,4.63373656 C8.54767348,4.52038474 8.31395488,4.46370968 8.03488372,4.46370968 C7.80232442,4.46370968 7.58372195,4.51176027 7.37906977,4.6078629 C7.17441758,4.70396553 7.00930295,4.85181352 6.88372093,5.05141129 C6.75813891,5.25100906 6.69069772,5.51343923 6.68139535,5.83870968 L5,5.83870968 C5.00930237,5.21773883 5.14883586,4.69534262 5.41860465,4.27150538 C5.68837344,3.84766813 6.05116051,3.52979497 6.50697674,3.31787634 C6.96279298,3.10595772 7.47209021,3 8.03488372,3 C8.65814265,3 9.19069547,3.11211805 9.63255814,3.33635753 C10.0744208,3.560597 10.4127895,3.88586256 10.6476744,4.31216398 C10.8825593,4.73846539 11,5.25223714 11,5.85349462 C11,6.28718855 10.9186055,6.68021777 10.755814,7.03259409 C10.5930224,7.3849704 10.3813967,7.7127001 10.1209302,8.01579301 C9.86046381,8.31888592 9.57907128,8.62074222 9.27674419,8.92137097 C9.01627777,9.17271631 8.83953535,9.44500301 8.74651163,9.73823925 C8.65348791,10.0314755 8.60465119,10.3653655 8.6,10.7399194 Z M6.90465116,13.046371 C6.90465116,12.7802406 6.99069681,12.5547724 7.1627907,12.3699597 C7.33488458,12.1851469 7.56976595,12.0927419 7.86744186,12.0927419 C8.16511777,12.0927419 8.39999914,12.1851469 8.57209302,12.3699597 C8.74418691,12.5547724 8.83023256,12.7802406 8.83023256,13.046371 C8.83023256,13.3125013 8.74418691,13.5379695 8.57209302,13.7227823 C8.39999914,13.907595 8.16511777,14 7.86744186,14 C7.56976595,14 7.33488458,13.907595 7.1627907,13.7227823 C6.99069681,13.5379695 6.90465116,13.3125013 6.90465116,13.046371 Z"
      })), c.a.createElement("g", {
        stroke: "none",
        "stroke-width": "1",
        fill: "none",
        "fill-rule": "evenodd"
      }, c.a.createElement("g", null, c.a.createElement("ellipse", {
        fill: "#A28352",
        cx: "8",
        cy: "8.5",
        rx: "8",
        ry: "8.5"
      }), c.a.createElement("g", {
        "fill-rule": "nonzero"
      }))));
    };

    xe.propTypes = {
      color: r.a.string,
      iconTitle: r.a.string,
      size: r.a.number,
      theme: r.a.object
    }, xe.defaultProps = {
      color: null,
      iconTitle: null,
      size: 26,
      theme: null
    };

    var be = Object(i.withTheme)(xe),
        Ve = function Ve(e) {
      var t = e.size,
          l = e.color,
          a = e.theme,
          n = e.iconTitle,
          r = l || a && a.iconColor;
      return c.a.createElement("svg", {
        viewBox: "0 0 14 14",
        width: t,
        height: t,
        color: r,
        fill: r
      }, c.a.createElement("title", null, n), c.a.createElement("g", {
        stroke: "none",
        "stroke-width": "1",
        fill: "none",
        "fill-rule": "evenodd"
      }, c.a.createElement("circle", {
        stroke: "#CCCCCC",
        cx: "7",
        cy: "7",
        r: "6.5"
      })));
    };

    Ve.propTypes = {
      color: r.a.string,
      iconTitle: r.a.string,
      size: r.a.number,
      theme: r.a.object
    }, Ve.defaultProps = {
      color: null,
      iconTitle: null,
      size: 26,
      theme: null
    };

    var ke = Object(i.withTheme)(Ve),
        je = function je(e) {
      var t = e.size,
          l = e.color,
          a = e.theme,
          n = e.iconTitle,
          r = l || a && a.iconColor;
      return c.a.createElement("svg", {
        viewBox: "0 0 14 14",
        width: t,
        height: t,
        color: r,
        fill: r
      }, c.a.createElement("title", null, n), c.a.createElement("g", {
        stroke: "none",
        "stroke-width": "1",
        fill: "none",
        "fill-rule": "evenodd"
      }, c.a.createElement("circle", {
        stroke: "#A28352",
        "stroke-width": "2",
        cx: "7",
        cy: "7",
        r: "6"
      })));
    };

    je.propTypes = {
      color: r.a.string,
      iconTitle: r.a.string,
      size: r.a.number,
      theme: r.a.object
    }, je.defaultProps = {
      color: null,
      iconTitle: null,
      size: 26,
      theme: null
    };

    var He = Object(i.withTheme)(je),
        _e = function _e(e) {
      var t = e.size,
          l = e.color,
          a = e.theme,
          n = e.iconTitle,
          r = l || a && a.iconColor;
      return c.a.createElement("svg", {
        viewBox: "0 0 23 23",
        width: t,
        height: t,
        color: r,
        fill: r
      }, c.a.createElement("title", null, n), c.a.createElement("g", {
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
      }, c.a.createElement("path", {
        d: "M11.5,21.5625 C17.0573653,21.5625 21.5625,17.0573653 21.5625,11.5 C21.5625,5.9426347 17.0573653,1.4375 11.5,1.4375 C5.9426347,1.4375 1.4375,5.9426347 1.4375,11.5 C1.4375,17.0573653 5.9426347,21.5625 11.5,21.5625 Z M23,11.5 C23,17.8512746 17.8512746,23 11.5,23 C5.14872538,23 0,17.8512746 0,11.5 C0,5.14872538 5.14872538,0 11.5,0 C17.8512746,0 23,5.14872538 23,11.5 Z",
        fill: r,
        fillRule: "nonzero"
      }), c.a.createElement("path", {
        d: "M10.668181,4 C11.0372072,4 11.336362,4.31624955 11.336362,4.70636315 L11.336362,12.0666672 L15.6768657,14.6886872 C15.9875728,14.8868349 16.0918946,15.3109125 15.9118628,15.6439714 C15.7318311,15.9770304 15.3332579,16.0973181 15.0140302,15.9149336 L10.3367632,13.089481 C10.1285894,12.9637737 10.0000773,12.7298 10,12.4763578 L10,4.70636315 C10,4.31624955 10.2991548,4 10.668181,4 Z",
        fill: r,
        fillRule: "nonzero"
      })));
    };

    _e.propTypes = {
      color: r.a.string,
      iconTitle: r.a.string,
      size: r.a.number,
      theme: r.a.object
    }, _e.defaultProps = {
      color: null,
      iconTitle: null,
      size: 26,
      theme: null
    };

    var Oe = Object(i.withTheme)(_e),
        Se = function Se(e) {
      var t = e.size,
          l = e.color,
          a = e.theme,
          n = e.iconTitle,
          r = l || a && a.iconColor;
      return c.a.createElement("svg", {
        viewBox: "0 0 37 37",
        width: t,
        height: t,
        color: r,
        fill: r,
        style: {
          overflow: "visible"
        }
      }, c.a.createElement("title", null, n), c.a.createElement("g", {
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }, c.a.createElement("path", {
        d: "M36.9999435,17.3492287 L36.9999435,19.0051194 C36.9953856,26.9762273 31.7480875,33.9949124 24.1036143,36.2550015 C16.4591411,38.5150905 8.23853312,35.4781929 3.89975614,28.7911922 C-0.439020846,22.1041916 0.137601805,13.3600425 5.31692653,7.30062247 C10.4962513,1.24120249 19.044477,-0.690033967 26.3259737,2.55420619",
        stroke: "#28A745",
        strokeWidth: "3"
      }), c.a.createElement("polyline", {
        stroke: "#28A745",
        strokeWidth: "3",
        points: "36.9999435 4.99508646 19.3076358 22.9950865 13.9999435 17.6004811"
      })));
    };

    Se.propTypes = {
      color: r.a.string,
      iconTitle: r.a.string,
      size: r.a.number,
      theme: r.a.object
    }, Se.defaultProps = {
      color: null,
      iconTitle: null,
      size: 26,
      theme: null
    };

    var Pe = Object(i.withTheme)(Se),
        Be = function Be(e) {
      var t = e.size,
          l = e.color,
          a = e.theme,
          n = e.iconTitle,
          r = l || a && a.iconColor;
      return c.a.createElement("svg", {
        viewBox: "0 0 17 9",
        width: t,
        height: t,
        color: r,
        fill: r
      }, c.a.createElement("title", null, n), c.a.createElement("g", {
        stroke: "none",
        "stroke-width": "1",
        fill: "none",
        "fill-rule": "evenodd"
      }, c.a.createElement("path", {
        d: "M8.49987082,-1.77635684e-15 L0.326861278,7.29532083 C-0.0813386995,7.65886282 -0.111278698,8.27913581 0.260001281,8.6789338 C0.630271261,9.07971079 1.26104123,9.10910779 1.6692412,8.7455668 L8.49987082,2.64865694 L15.3305104,8.7455668 C15.7377104,9.10910779 16.3704804,9.07971079 16.7407504,8.6789338 C17.1110303,8.27913581 17.0810803,7.65886282 16.6738804,7.29532083 L8.49987082,-1.77635684e-15 Z",
        fill: "#A28352",
        transform: "translate(8.500000, 4.500000) scale(-1, 1) rotate(-180.000000) translate(-8.500000, -4.500000) "
      })));
    };

    Be.propTypes = {
      color: r.a.string,
      iconTitle: r.a.string,
      size: r.a.number,
      theme: r.a.object
    }, Be.defaultProps = {
      color: null,
      iconTitle: null,
      size: 26,
      theme: null
    };

    var Ae = Object(i.withTheme)(Be),
        Ze = function Ze(e) {
      var t = e.size,
          l = e.color,
          a = e.theme,
          n = e.iconTitle,
          r = l || a && a.iconColor;
      return c.a.createElement("svg", {
        width: t,
        height: t,
        viewBox: "0 0 14 14",
        color: r,
        fill: r
      }, c.a.createElement("title", null, n), c.a.createElement("g", {
        stroke: "none",
        "stroke-width": "1",
        fill: "none",
        "fill-rule": "evenodd"
      }, c.a.createElement("circle", {
        id: "Circle",
        fill: "#A28352",
        cx: "7",
        cy: "7",
        r: "7"
      }), c.a.createElement("polyline", {
        stroke: "#FFFFFF",
        "stroke-width": "2",
        points: "4 7.71934024 6.44247269 10 11 4"
      })));
    };

    Ze.propTypes = {
      color: r.a.string,
      iconTitle: r.a.string,
      size: r.a.number,
      theme: r.a.object
    }, Ze.defaultProps = {
      color: null,
      iconTitle: null,
      size: 26,
      theme: null
    };

    var We = Object(i.withTheme)(Ze),
        Re = function Re(e) {
      var t = e.size,
          l = e.color,
          a = e.theme,
          n = e.iconTitle,
          r = l || a && a.iconColor;
      return c.a.createElement("svg", {
        width: t,
        height: t,
        viewBox: "0 0 12 12",
        color: r,
        fill: r
      }, c.a.createElement("title", null, n), c.a.createElement("defs", null, c.a.createElement("filter", {
        id: "filter-1"
      }, c.a.createElement("feColorMatrix", {
        in: "SourceGraphic",
        type: "matrix",
        values: "0 0 0 0 0.200000 0 0 0 0 0.200000 0 0 0 0 0.200000 0 0 0 1.000000 0"
      }))), c.a.createElement("g", {
        stroke: "none",
        "stroke-width": "1",
        fill: "none",
        "fill-rule": "evenodd",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }, c.a.createElement("g", {
        filter: "url(#filter-1)"
      }, c.a.createElement("g", null, c.a.createElement("line", {
        x1: "12",
        y1: "0",
        x2: "0",
        y2: "12",
        stroke: "#000000",
        "stroke-width": "2"
      }), c.a.createElement("line", {
        x1: "0",
        y1: "0",
        x2: "12",
        y2: "12",
        stroke: "#000000",
        "stroke-width": "2"
      })))));
    };

    Re.propTypes = {
      color: r.a.string,
      iconTitle: r.a.string,
      size: r.a.number,
      theme: r.a.object
    }, Re.defaultProps = {
      color: null,
      iconTitle: null,
      size: 26,
      theme: null
    };
    var De = Object(i.withTheme)(Re);
  }]);
});